webpackJsonp([8],{

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return lxBidTracker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return lxCidTracker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(181);



var lxBidTracker = function lxBidTracker() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var bid = opts.bid;
  if (!bid || bid === "") {
    console.error('bid is necessary！');
    return;
  }
  var type = opts.type || 'moduleClick';
  var cid = opts.cid || '';
  var options = {};
  if (cid) {
    options.cid = cid;
  }
  var customParam = opts.customParam || {};
  var custom = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    AppVersion: '',
    hotel_id: '',
    user_id: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.userInfo.userId,
    agency_id: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.userInfo.agencyId
  }, customParam);
  var valLab = {
    custom: custom
  };
  window.LXAnalytics && window.LXAnalytics(type, bid, valLab, options);
};

var lxCidTracker = function lxCidTracker(path) {
  var cid = path.meta && path.meta.cid;
  var valLab = {};
  if (vm.$store.state.userInfo.userId && vm.$store.state.userInfo.agencyId && cid) {
    valLab = {
      custom: {
        AppVersion: '',
        hotel_id: '',
        user_id: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.userInfo.userId,
        agency_id: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.userInfo.agencyId
      }
    };
    window.LXAnalytics && window.LXAnalytics('pageView', valLab, {}, cid);
  }
};

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = core_library;

/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_menu__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_menu_crm__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isCRMUser__ = __webpack_require__(31);




function getConfig(cPath, cMenus) {
  var menu = cMenus.filter(function (m) {
    return m.path === cPath;
  });
  return menu[0];
};

/* harmony default export */ __webpack_exports__["a"] = (function (path) {
  var ret = [];
  var menus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_isCRMUser__["a" /* default */])() ? __WEBPACK_IMPORTED_MODULE_1__constants_menu_crm__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_0__constants_menu__["a" /* default */];
  var paths = path.substring(1).split('/');
  var parentConfig = null;
  var subConfig = null;

  if (paths.length === 1) {
    parentConfig = getConfig('/' + paths[0], menus);
    subConfig = parentConfig;
  } else {
    parentConfig = getConfig(paths[0], menus);
    subConfig = getConfig('/' + paths[0] + '/' + paths[1], parentConfig ? parentConfig.children : []);
  }
  ret.push(parentConfig);
  ret.push(subConfig);
  return ret;
});

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(347);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);

var state = {
  userInfo: {},
  orgTree: {},
  unreadMessageInfo: {}
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store({
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */]
}));

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(12))(94);

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var host = window.location.host;

var testUrls = ['test2', 'alitest', 'alitest1', 'assemble', 'pre'];

var collegeUrl = '';

if (testUrls.indexOf(host.substr(0, host.indexOf('.'))) > -1) {
  collegeUrl = 'https://13766-nygpt-sl-ipu.it.test.sankuai.com/app/course/courseCatalog';
} else {
  collegeUrl = 'https://rms-ipu.sankuai.com/app/course/courseCatalog';
}

var menu = [{
  id: '9',
  name: '首页',
  icon: 'icon-shouyehq',
  path: '/'
}, {
  id: '20',
  name: '菜品管理',
  path: 'Menu',
  icon: 'icon-caipinguanli',
  children: [{
    id: '201003',
    name: '菜品库',
    oldPath: '/hq-web/food/stock'
  }, {
    id: '202001',
    name: '总部菜谱',
    path: '/Menu/MenuHqList'
  }, {
    id: '206001',
    name: '菜谱发布管理',
    path: '/Menu/MenuManage'
  }]
}, {
  id: '30',
  path: 'Payment',
  name: '支付优惠',
  icon: 'icon-zhifuyouhui',
  children: [{
    id: '301001',
    name: '付款方式',

    path: '/Payment/PayMethod'
  }, {
    id: '302001',
    name: '折扣方案',
    oldPath: '/hq-web/pay/discount'
  }, {
    id: '303001',
    name: '服务费',
    oldPath: '/hq-web/pay/fee'
  }]
}, {
  id: '40',
  name: '辅助信息',
  icon: 'icon-fuzhuxinxi',
  children: [{
    id: '4010',
    name: '辅助信息',
    sign: [401001, 402001, 403001, 404001, 405001, 406001],
    oldPath: 'AUXI'
  }]
}, {
  id: '100',
  name: '扫码点餐',
  icon: 'icon-weicanting',
  children: [{
    id: '10010',
    name: '扫码点餐展示',
    sign: [100100101, 100100201],
    oldPath: 'WCT_SHOW'
  }, {
    id: '1002001',
    name: '公众号授权设置',
    oldPath: '/hq-web/wct/auth'
  }, {
    id: '10030',
    name: '二维码管理',
    sign: [100300101, 100300201],
    oldPath: 'WCT_QR'
  }]
}, {
  id: '2000000050',
  name: '会员管理',
  path: 'Member',
  icon: 'icon-huiyuanguanli',
  hasNewPoint: true,
  children: [{
    id: '_2000000050A001',
    name: '一键迁移',
    path: '/Member/MemberTransfer',
    hasNewPoint: true
  }, {
    id: '2000503001',
    name: '会员信息',
    oldPath: '/hq-web/crm/member'
  }, {
    id: '2000501001',
    name: '会员卡类型',
    oldPath: '/hq-web/crm/cardtype'
  }, {
    id: '2050200101_2050200201',
    name: '批量制会员卡',
    oldPath: 'CRM_CARD'
  }, {
    id: '2000504001',
    name: '积分兑换方案',
    oldPath: '/hq-web/crm/credit'
  }, {
    id: '2000505001',
    name: '微信会员中心',
    oldPath: '/hq-web/weixin/member'
  }]
}, {
  id: '70',
  name: '门店库存管理',
  icon: 'icon-mendiankucunguanli',
  children: [{
    id: '701001',
    name: '门店采购订单',
    oldPath: '/hq-web/sds/hotel/order'
  }, {
    id: '702001',
    name: '门店直配订单',
    oldPath: '/hq-web/sds/hotel/order/distribution'
  }, {
    id: '702101',
    name: '门店调拨管理',
    oldPath: '/hq-web/sds/hotel/transfer'
  }, {
    id: '701701',
    name: '门店采购统计',
    oldPath: 'HOTEL_PURCHASE'
  }, {
    id: '7011',
    name: '门店报表统计',
    sign: [70110101, 70110201, 70110301, 70110401, 70110501, 70110601, 70110701, 70110801],
    oldPath: 'SDS_HOTEL'
  }, {
    id: '701201',
    name: '门店仓库管理',
    oldPath: '/hq-web/sds/warehouse/list/hotel'
  }, {
    id: '7018',
    name: '原材料管理',
    sign: [70180101, 701802, 701803, 701804],
    oldPath: 'SDS_GOODS'
  }, {
    id: '901001',
    name: '门店原材料调价管理',
    oldPath: '/hq-web/sds/group/priceAgreement/done'
  }, {
    id: '701301',
    name: '门店供应商',
    oldPath: '/hq-web/sds/supplier/list/hotel'
  }, {
    id: '701401',
    name: '门店成本卡',
    oldPath: '/hq-web/sds/hotel/foodsbom'
  }, {
    id: '701501',
    name: '库存数据下发',
    oldPath: '/hq-web/data/issue'
  }]
}, {
  id: '80',
  name: '总部库存管理',
  icon: 'icon-zongdiankucunguanli',
  children: [{
    id: '801001',
    name: '总部订单管理',
    oldPath: '/hq-web/sds/group/order'
  }, {
    id: '801101',
    name: '总部入库管理',
    oldPath: '/hq-web/sds/group/in'
  }, {
    id: '801201',
    name: '总部出库管理',
    oldPath: '/hq-web/sds/group/out'
  }, {
    id: '801301',
    name: '总部调拨管理',
    oldPath: '/hq-web/sds/group/transfer'
  }, {
    id: '801401',
    name: '总部盘点管理',
    oldPath: '/hq-web/sds/group/taking'
  }, {
    id: '8016',
    name: '总部报表统计',
    sign: [80160101, 80160201, 80160301, 80160401, 80160501, 80160601],
    oldPath: 'SDS_GROUP'
  }, {
    id: '801701',
    name: '总部仓库管理',
    oldPath: '/hq-web/sds/warehouse/list/group'
  }, {
    id: '801801',
    name: '总部供应商',
    oldPath: '/hq-web/sds/supplier/list/group'
  }, {
    id: '801901',
    name: '工作流配置',
    oldPath: '/hq-web/sds/group/workflow'
  }]
}, {
  id: '60',
  name: '营业收入报表',
  path: 'BusinessReport',
  icon: 'icon-yingyeshourubaobiao',
  children: [{
    id: '601001',
    name: '营业汇总表',
    path: '/BusinessReport/BusiStatistics'
  }, {
    id: '601101',
    name: '交班信息表',
    path: '/BusinessReport/GetoDuty'
  }, {
    id: '601201',
    name: '付款类型汇总表',
    path: '/BusinessReport/PayType'
  }, {
    id: '601401',
    name: '堂食时段账单统计表',
    path: '/BusinessReport/BillDetail'
  }, {
    id: '601501',
    name: '开票统计表',
    path: '/BusinessReport/InvoiceReport'
  }, {
    id: '601601',
    name: '结算信息统计表',
    path: '/BusinessReport/SettlementStatistics'
  }]
}, {
  id: '110',
  name: '菜品销售报表',
  path: 'FoodReport',
  icon: 'icon-caipinxiaoshoubaobiao',
  children: [{
    id: '1101001',
    name: '菜品销售汇总表',
    path: '/FoodReport/Gather'
  }, {
    id: '1101101',
    name: '菜品销售排行',
    path: '/FoodReport/Rank'
  }, {
    id: '1101201',
    name: '菜品分类占比',
    path: '/FoodReport/FoodType'
  }, {
    id: '1101501',
    name: '加料销售报表',
    path: '/FoodReport/AdditionSaleReport'
  }, {
    id: '1101301',
    name: '菜品时段销售表',
    path: '/FoodReport/Period'
  }, {
    id: '1101401',
    name: '菜品销售提成表',
    path: '/FoodReport/Commission'
  }]
}, {
  id: '2000000120',
  name: '会员相关报表',
  icon: 'icon-huiyuanxiangguanbaobiao',
  children: [{
    id: '2001201001',
    name: '会员统计表',
    oldPath: '/hq-web/report/crm/member/stat'
  }, {
    id: '2001201101',
    name: '会员充值明细表',
    oldPath: '/hq-web/report/crm/card/recharge'
  }, {
    id: '2001201201',
    name: '会员储值结算报表',
    oldPath: '/hq-web/report/crm/card/balance'
  }, {
    id: '2001201301',
    name: '门店结算报表',
    oldPath: '/hq-web/report/crm/hotelMemberBalance'
  }]
}, {
  id: '130',
  name: '收银异常操作',
  path: 'CashierException',
  icon: 'icon-shouyinyichangbaobiao',
  children: [{
    id: '1301001',
    name: '赠送明细表',
    path: '/CashierException/FoodGift'
  }, {
    id: '1301101',
    name: '退菜明细表',
    path: '/CashierException/FoodBack'
  }, {
    id: '1301201',
    name: '免单明细表',
    path: '/CashierException/FreeOfChargeDetail'
  }, {
    id: '1301301',
    name: '折扣明细表',
    path: '/CashierException/DiscountDetail'
  }, {
    id: '1301401',
    name: '反结明细表',
    path: '/CashierException/AntiSettlement'
  }]
}, {
  id: '190',
  name: '历史数据查询',
  icon: 'icon-huiyuanxiangguanbaobiao',
  children: [{
    id: '1901001',
    name: '会员统计表',
    oldPath: '/hq-web/report/crm/member/stat'
  }, {
    id: '1902001',
    name: '会员充值明细表',
    oldPath: '/hq-web/report/crm/card/recharge'
  }, {
    id: '1903001',
    name: '会员储值结算报表',
    oldPath: '/hq-web/report/crm/card/balance'
  }, {
    id: '1904001',
    name: '门店结算报表',
    oldPath: '/hq-web/report/crm/hotelMemberBalance'
  }]
}, {
  id: '140',
  name: '系统设置',
  path: 'System',
  icon: 'icon-xitongshezhi',
  children: [{
    id: '14010',
    name: '预约下载中心',
    path: '/System/Download',
    className: 'appoint-download'
  }]
}, {
  id: '9600',
  name: '服务中心',
  path: 'Service',
  icon: 'icon-fuwuzhongxin',
  children: [{
    id: "9601",
    name: "帮助中心",
    path: "https://rms-help.meituan.com/web/fe.rms-help-pro/index.html?appCode=100&module=1001"
  }, {
    id: "9602",
    name: "收银讲堂",
    path: collegeUrl
  }, {
    id: "9603",
    name: "软件下载",
    path: "/Service/DownloadCenter"
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (menu);

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(716)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(764),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getChildrenLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDataById; });
/* unused harmony export getDataByHotelId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return flatern; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

var getChildrenLength = function getChildrenLength(item) {
  var len = 0;
  len += (item.children || []).length;
  (item.children || []).forEach(function (da) {
    len += getChildrenLength(da);
  });
  return len;
};

var map = {};
var hotelMap = {};

var findChild = function findChild(list, rootId) {
  list.forEach(function (item) {
    if (item.type !== 4) {
      item.children = [];
      map[item.id] = item;
      if (item.id !== 0) {
        hotelMap[item.hotelId] = item;
      }
    }
  });
  var ret = [];
  for (var i in map) {
    var item = map[i];
    if (map[item.pid]) {
      map[item.pid].children.push(item);
    }
    if (item.pid === rootId) {
      ret.push(item);
    }
  }
  var result = [];
  for (var _i = 0, length = ret.length; _i < length; _i++) {
    if (ret[_i].pid === rootId && ret[_i].type !== 3 && ret[_i].children.length === 0) {
      continue;
    } else {
      result.push(ret[_i]);
    }
  }
  return result;
};

var getDataById = function getDataById(treeData, id) {
  if (map[id]) {
    return treeData[map[id].index];
  } else {
    return null;
  }
};

var getDataByHotelId = function getDataByHotelId(treeData, id) {
  return treeData[hotelMap[id].index];
};

var index = 0;
var init = function init() {
  index = 0;
};
var flatern = function flatern(node, level, pIndex) {
  var ret = [];
  var childLength = node.children.length;
  var da = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(node, {
    index: index,
    pIndex: pIndex || 0,
    level: level,
    visible: true,
    expanded: true,
    checkStatus: {
      checked: 0,
      childChecked: childLength === 0 ? null : [childLength, 0, 0],
      childLength: childLength
    }
  });
  ret.push(da);
  level = level + 1;
  var _pIndex = index;
  node.children.forEach(function (n) {
    index++;
    ret = ret.concat(flatern(n, level, _pIndex));
  });
  return ret;
};

/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_menu_uxiliary__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isCRMUser__ = __webpack_require__(31);



var menusList = null;

/* harmony default export */ __webpack_exports__["a"] = (function (type) {
  if (menusList === null) {
    menusList = JSON.parse(localStorage.getItem('menuList'));
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_isCRMUser__["a" /* default */])()) {
      menusList = menusList.chain;
    }
  }
  if (type.indexOf('/') !== -1) {
    return type;
  }
  var ret = '';
  var ids = __WEBPACK_IMPORTED_MODULE_0__constants_menu_uxiliary__["a" /* default */][type];
  for (var i in ids) {
    if (menusList.indexOf(window.parseInt(i)) !== -1) {
      ret = ids[i];
      break;
    }
  }
  return "/hq-web" + ret;
});

/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);



/* harmony default export */ __webpack_exports__["a"] = (function (isHQ) {
  var queryData = { platform: isHQ ? 'HQ' : 'IRS', isRead: 0, start: 0, size: 3 };
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/irs-api/ces-web/user/api/v3/message/totalList', __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(queryData)).then(function (res) {
    global.vm.$emit('refresh_message', res.data);
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = (['/Midware', '/MessageCenter']);

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(12))(51);

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var menu = [{
  id: '1',
  name: '首页',
  icon: 'icon-shouyehq',
  path: '/'
}, {
  id: '10',
  name: '组织结构',
  icon: 'icon-zuzhijigou',
  children: [{
    id: '1010',
    name: '机构管理',
    sign: [101001, 105001],
    oldPath: 'AGENCY'
  }, {
    id: '102001',
    name: '部门管理',
    oldPath: '/hq-web/org/dept'
  }, {
    id: '103001',
    name: '岗位权限',
    oldPath: '/hq-web/org/post'
  }, {
    id: '104001',
    name: '员工管理',
    oldPath: '/hq-web/org/employee'
  }]
}, {
  id: '20',
  name: '菜品管理',
  path: 'Menu',
  icon: 'icon-caipinguanli',
  children: [{
    id: '201003',
    name: '菜品库',
    oldPath: '/hq-web/food/stock'
  }, {
    id: '202001',
    name: '总部菜谱',
    path: '/Menu/MenuHqList'
  }, {
    id: '206001',
    name: '菜谱发布管理',
    path: '/Menu/MenuManage'
  }]
}, {
  id: '30',
  name: '支付优惠',
  path: 'Payment',
  icon: 'icon-zhifuyouhui',
  children: [{
    id: '301001',
    name: '付款方式',
    path: '/Payment/PayMethod'
  }, {
    id: '302001',
    name: '折扣方案',
    oldPath: '/hq-web/pay/discount'
  }, {
    id: '303001',
    name: '服务费',
    oldPath: '/hq-web/pay/fee'
  }]
}, {
  id: '40',
  name: '辅助信息',
  icon: 'icon-fuzhuxinxi',
  children: [{
    id: '4010',
    name: '辅助信息',
    sign: [401001, 402001, 403001, 404001, 405001, 406001],
    oldPath: 'AUXI'
  }]
}, {
  id: '100',
  name: '扫码点餐',
  icon: 'icon-weicanting',
  children: [{
    id: '10010',
    name: '扫码点餐展示',
    sign: [100100101, 100100201],
    oldPath: 'WCT_SHOW'
  }, {
    id: '1002001',
    name: '公众号授权设置',
    oldPath: '/hq-web/wct/auth'
  }, {
    id: '10030',
    name: '二维码管理',
    sign: [100300101, 100300201],
    oldPath: 'WCT_QR'
  }]
}, {
  id: '50',
  name: '会员管理',
  path: 'Member',
  icon: 'icon-huiyuanguanli',
  hasNewPoint: true,
  children: [{
    id: '_50A001',
    name: '一键迁移',
    path: '/Member/MemberTransfer',
    hasNewPoint: true
  }, {
    id: '503001',
    name: '会员信息',
    oldPath: '/hq-web/crm/member'
  }, {
    id: '501001',
    name: '会员卡类型',
    oldPath: '/hq-web/crm/cardtype'
  }, {
    id: '50200101_50200201',
    name: '批量制会员卡',
    oldPath: 'CRM_CARD'
  }, {
    id: '504001',
    name: '积分兑换方案',
    oldPath: '/hq-web/crm/credit'
  }, {
    id: '505001',
    name: '微信会员中心',
    oldPath: '/hq-web/weixin/member'
  }]
}, {
  id: '70',
  name: '门店库存管理',
  icon: 'icon-mendiankucunguanli',
  children: [{
    id: '701001',
    name: '门店采购订单',
    oldPath: '/hq-web/sds/hotel/order'
  }, {
    id: '702001',
    name: '门店直配订单',
    oldPath: '/hq-web/sds/hotel/order/distribution'
  }, {
    id: '702101',
    name: '门店调拨管理',
    oldPath: '/hq-web/sds/hotel/transfer'
  }, {
    id: '701701',
    name: '门店采购统计',
    oldPath: 'HOTEL_PURCHASE'
  }, {
    id: '7011',
    name: '门店报表统计',
    sign: [70110101, 70110201, 70110301, 70110401, 70110501, 70110601, 70110701, 70110801],
    oldPath: 'SDS_HOTEL'
  }, {
    id: '701201',
    name: '门店仓库管理',
    oldPath: '/hq-web/sds/warehouse/list/hotel'
  }, {
    id: '7018',
    name: '原材料管理',
    sign: [70180101, 701802, 701803, 701804],
    oldPath: 'SDS_GOODS'
  }, {
    id: '901001',
    name: '门店原材料调价管理',
    oldPath: '/hq-web/sds/group/priceAgreement/done'
  }, {
    id: '701301',
    name: '门店供应商',
    oldPath: '/hq-web/sds/supplier/list/hotel'
  }, {
    id: '701401',
    name: '门店成本卡',
    oldPath: '/hq-web/sds/hotel/foodsbom'
  }, {
    id: '701501',
    name: '库存数据下发',
    oldPath: '/hq-web/data/issue'
  }]
}, {
  id: '80',
  name: '总部库存管理',
  icon: 'icon-zongdiankucunguanli',
  children: [{
    id: '801001',
    name: '总部订单管理',
    oldPath: '/hq-web/sds/group/order'
  }, {
    id: '801101',
    name: '总部入库管理',
    oldPath: '/hq-web/sds/group/in'
  }, {
    id: '801201',
    name: '总部出库管理',
    oldPath: '/hq-web/sds/group/out'
  }, {
    id: '801301',
    name: '总部调拨管理',
    oldPath: '/hq-web/sds/group/transfer'
  }, {
    id: '801401',
    name: '总部盘点管理',
    oldPath: '/hq-web/sds/group/taking'
  }, {
    id: '8016',
    name: '总部报表统计',
    sign: [80160101, 80160201, 80160301, 80160401, 80160501, 80160601],
    oldPath: 'SDS_GROUP'
  }, {
    id: '801701',
    name: '总部仓库管理',
    oldPath: '/hq-web/sds/warehouse/list/group'
  }, {
    id: '801801',
    name: '总部供应商',
    oldPath: '/hq-web/sds/supplier/list/group'
  }, {
    id: '801901',
    name: '工作流配置',
    oldPath: '/hq-web/sds/group/workflow'
  }]
}, {
  id: '60',
  name: '营业收入报表',
  path: 'BusinessReport',
  icon: 'icon-yingyeshourubaobiao',
  children: [{
    id: '601001',
    name: '营业汇总表',
    path: '/BusinessReport/BusiStatistics'
  }, {
    id: '601101',
    name: '交班信息表',
    path: '/BusinessReport/GetoDuty'
  }, {
    id: '601201',
    name: '付款类型汇总表',
    path: '/BusinessReport/PayType'
  }, {
    id: '601401',
    name: '堂食时段账单统计表',
    path: '/BusinessReport/BillDetail'
  }, {
    id: '601501',
    name: '开票统计表',
    path: '/BusinessReport/InvoiceReport'
  }]
}, {
  id: '110',
  name: '菜品销售报表',
  path: 'FoodReport',
  icon: 'icon-caipinxiaoshoubaobiao',
  children: [{
    id: '1101001',
    name: '菜品销售汇总表',
    path: '/FoodReport/Gather'
  }, {
    id: '1101101',
    name: '菜品销售排行',
    path: '/FoodReport/Rank'
  }, {
    id: '1101201',
    name: '菜品分类占比',
    path: '/FoodReport/FoodType'
  }, {
    id: '1101501',
    name: '加料销售报表',
    path: '/FoodReport/AdditionSaleReport'
  }, {
    id: '1101301',
    name: '菜品时段销售表',
    path: '/FoodReport/Period'
  }, {
    id: '1101401',
    name: '菜品销售提成表',
    path: '/FoodReport/Commission'
  }]
}, {
  id: '120',
  name: '会员相关报表',
  icon: 'icon-huiyuanxiangguanbaobiao',
  children: [{
    id: '1201001',
    name: '会员统计表',
    oldPath: '/hq-web/report/crm/member/stat'
  }, {
    id: '1201101',
    name: '会员充值明细表',
    oldPath: '/hq-web/report/crm/card/recharge'
  }, {
    id: '1201201',
    name: '会员储值结算报表',
    oldPath: '/hq-web/report/crm/card/balance'
  }, {
    id: '1201301',
    name: '门店结算报表',
    oldPath: '/hq-web/report/crm/hotelMemberBalance'
  }]
}, {
  id: '130',
  name: '收银异常操作',
  path: 'CashierException',
  icon: 'icon-shouyinyichangbaobiao',
  children: [{
    id: '1301001',
    name: '赠送明细表',
    path: '/CashierException/FoodGift'
  }, {
    id: '1301101',
    name: '退菜明细表',
    path: '/CashierException/FoodBack'
  }, {
    id: '1301201',
    name: '免单明细表',
    path: '/CashierException/FreeOfChargeDetail'
  }, {
    id: '1301301',
    name: '折扣明细表',
    path: '/CashierException/DiscountDetail'
  }, {
    id: '1301401',
    name: '反结明细表',
    path: '/CashierException/AntiSettlement'
  }]
}, {
  id: '140',
  name: '系统设置',
  path: 'System',
  icon: 'icon-xitongshezhi',
  children: [{
    id: '14010',
    name: '预约下载中心',
    path: '/System/Download',
    className: 'appoint-download'
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (menu);

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_UNREAD_MESSAGE_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_USER_AND_HOTEL_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ORG_TREE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_CRM_UPDATE_CLOSE; });

var SET_UNREAD_MESSAGE_INFO = 'SET_UNREAD_MESSAGE_INFO';
var SET_USER_AND_HOTEL_INFO = 'SET_USER_AND_HOTEL_INFO';
var SET_ORG_TREE = 'SET_ORG_TREE';
var GET_CRM_UPDATE_CLOSE = 'GET_CRM_UPDATE_CLOSE';

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCookie;
/* harmony export (immutable) */ __webpack_exports__["b"] = setCookie;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeCookie;

function getCookie(name) {
  var arr = void 0,
      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) {
    return unescape(arr[2]);
  } else {
    return null;
  }
}

function setCookie(name, value) {
  var days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;
  var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/';
  var domain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

  var Days = days;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  var curCookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=" + path;
  if (domain) {
    curCookie += ";domain=" + domain;
  }
  document.cookie = curCookie;
}

function removeCookie(name) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  var domain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  var curCookie = "";
  if (cval !== null) {
    curCookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ";path=" + path;
    if (domain) {
      curCookie += ";domain=" + domain;
    }
    document.cookie = curCookie;
  }
}

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_DateShortCut_DateShortCut_vue__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_DateShortCut_DateShortCut_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_DateShortCut_DateShortCut_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Collapse_Collapse_vue__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Collapse_Collapse_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_Collapse_Collapse_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_FontTip_FontTip__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_FontTip_FontTip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_FontTip_FontTip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_AgencyTree_AgencyTree__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_AgencyTree_AgencyTree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ui_AgencyTree_AgencyTree__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_AgencyTreeTransfer_AgencyTreeDetail__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_AgencyTreeTransfer_AgencyTreeDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ui_AgencyTreeTransfer_AgencyTreeDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_SelectInterval_SelectInterval__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_SelectInterval_SelectInterval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ui_SelectInterval_SelectInterval__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_DescText_DescText_vue__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_DescText_DescText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ui_DescText_DescText_vue__);











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('date-short-cut', __WEBPACK_IMPORTED_MODULE_2__ui_DateShortCut_DateShortCut_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('hq-collapse', __WEBPACK_IMPORTED_MODULE_3__ui_Collapse_Collapse_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('font-tip', __WEBPACK_IMPORTED_MODULE_4__ui_FontTip_FontTip___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('agency-tree', __WEBPACK_IMPORTED_MODULE_5__ui_AgencyTree_AgencyTree___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('agency-transfer', __WEBPACK_IMPORTED_MODULE_6__ui_AgencyTreeTransfer_AgencyTreeDetail___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('select-interval', __WEBPACK_IMPORTED_MODULE_7__ui_SelectInterval_SelectInterval___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('desc-text', __WEBPACK_IMPORTED_MODULE_8__ui_DescText_DescText_vue___default.a);

__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a.DatePicker.mixins[0].props.editable.default = false;
__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a.DatePicker.mixins[0].props.clearable.default = false;
__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a.DatePicker.props.valueFormat = {
  default: 'timestamp'
};
__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a.Pagination.props.layout.default = 'total, sizes, jumper, -> ,prev, pager, next';

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a);

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isCRMUser__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_lxTracker__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_cookie__ = __webpack_require__(25);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('authority', {
  inserted: function inserted(el, binding, vnode) {
    var menuList = JSON.parse(localStorage.menuList);
    var menus = [];
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_isCRMUser__["a" /* default */])()) {
      menus = menuList.chain;
    } else {
      menus = menuList;
    }

    var flag = ~menus.indexOf(binding.value);
    if (!flag) {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      } else {
        el.innerHTML = '';
        el.style.display = 'none';

        vnode.elm.__vue__ && vnode.elm.__vue__.$off();

        el.tagName === 'A' && el.setAttribute('href', 'javascript:void(0)');

        if (vnode.data.on && vnode.data.on.click) {
          vnode.data.on.click.fn = function () {
            return;
          };
        }
        ;
        if (vnode.data.nativeOn && vnode.data.nativeOn.click) {
          vnode.data.nativeOn.click.fn = function () {
            return;
          };
        }
        ;
      }
    }
  }
});

var pendingBtns = {};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('multi-request', {
  bind: function bind(el, binding) {
    var btnText = el.innerHTML;
    el.onclick = function (e) {
      pendingBtns[e.currentTarget.id || 'saveBtn'] = {
        el: e.currentTarget,
        buttonText: e.currentTarget.innerHTML
      };
      e.currentTarget.innerHTML = '操作中';
      e.currentTarget.disabled = 'disabled';
      e.currentTarget.className += ' is-loading';
    };
  }
});

setTimeout(function () {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$resetBtn = function () {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'saveBtn';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    setTimeout(function () {
      var el = pendingBtns[id].el;
      el.innerHTML = pendingBtns[id].buttonText;
      el.disabled = '';
      el.className = el.className.replace('is-loading', '');
      delete pendingBtns[id];
    }, 300);
  };
}, 0);

function clickHandler(binding, cid) {
  return function () {
    binding.value.cid = cid;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_lxTracker__["b" /* lxBidTracker */])(binding.value);
  };
}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('tracker', {
  bind: function bind(el, binding, vnode) {
    try {
      var route = vnode.context.$route.meta;
      var cid = route && route.cid ? route.cid : '';
      el.addEventListener('click', clickHandler(binding, cid));
    } catch (e) {
      console.log(e);
    }
  },
  unbind: function unbind(el) {
    el.removeEventListener('click', clickHandler);
  }
});

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadSubApp", function() { return loadSubApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addRoutes", function() { return addRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "navigateTo", function() { return navigateTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBAPP_MENU", function() { return SUBAPP_MENU; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_cookie__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_handleGrayByLocalstorage__ = __webpack_require__(81);




var loadSubApp = function loadSubApp(subApp) {
  if (SUBAPP_MENU[subApp] && SUBAPP_MENU[subApp].status === 'loaded') {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(SUBAPP_MENU[subApp]);
  } else {
    return global.vm.$staticUtils.createScript(SUBAPP_MENU[subApp].entry).then(function (res) {
      SUBAPP_MENU[subApp].status = 'loaded';
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(SUBAPP_MENU[subApp]);
    });
  }
};

var addRoutes = function addRoutes(routes) {
  global.vm.$router.addRoutes(routes);
};

var navigateTo = function navigateTo(routeParams) {
  global.vm.$router.push(routeParams);
};

var SUBAPP_MENU = getSubAppMenu();

function getSubAppMenu() {
  var menus = {
    "/MenuManage/FoodManage/Upload": {
      entry: '/food-web/static/batch-upload-entry.js',
      status: 'unload'
    },
    '/BusinessReport/GetoDuty': {
      entry: '/report-dinein-web/static/gotoduty-entry.js',
      status: 'unload'
    },
    '/System/Download': {
      entry: '/report-component-web/static/appoint-download-entry.js',
      status: 'unload'
    },
    '/Payment/PayMethod': {
      entry: '/pay-web/static/hq-pay-entry.js',
      status: 'unload'
    }
  };

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_handleGrayByLocalstorage__["a" /* checkGrayItem */])('pingxin_fe_hq-static_feature')) {
    delete menus["/System/Download"];
  }

  return menus;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return track; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

var track = function track(params) {
  if (_hmt) {
    _hmt.push(['_trackEvent'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(params)));
  }
};

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return vueErrorHandel; });
/* unused harmony export addError */
function formatComponentName(vm) {
  if (vm.$root === vm) {
    return 'root instance';
  }

  var name = vm._isVue ? vm.$options.name || vm.$options._componentTag : vm.name;
  return (name ? 'component <' + name + '>' : 'anonymous component') + (vm._isVue && vm.$options.__file ? ' at ' + vm.$options.__file : '');
};

var vueErrorHandel = function vueErrorHandel(error, vm, info) {
  var metaData = {};

  if (Object.prototype.toString.call(vm) === '[object Object]') {
    metaData.componentName = formatComponentName(vm);
    metaData.propsData = vm.$options && vm.$options.propsData;
  }
  if (info && typeof info !== 'undefined') {
    metaData.lifecycleHook = info;
  }
  if (window.Owl) {
    window.Owl.addError(error, {
      tags: metaData });
  }
  console.error(error);
};

var addError = function addError(error) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    combo: false,
    level: 'error',
    category: 'jsError',
    tags: {}
  };

  if (window.Owl) {
    window.Owl.addError(error, opts);
  }
};

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_cookie__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_handleGrayByLocalstorage__ = __webpack_require__(81);





var Dashboard = function Dashboard(r) {
  return __webpack_require__.e/* require.ensure */(6).then((function () {
    return r(__webpack_require__(817));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var MenuManage = function MenuManage(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__(837));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var MenuRepublish = function MenuRepublish(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__(804));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var MenuHqList = function MenuHqList(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__(836));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var MenuPublish = function MenuPublish(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__(838));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var FoodEdit = function FoodEdit(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__(835));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var BusiStatistics = function BusiStatistics(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__(806));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PayType = function PayType(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__(808));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var InvoiceReport = function InvoiceReport(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__(807));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var BillDetail = function BillDetail(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__(805));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SettlementStatistics = function SettlementStatistics(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__(811));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SettlementHotelSummary = function SettlementHotelSummary(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__(810));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SettlementHotelDetail = function SettlementHotelDetail(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__(809));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Gather = function Gather(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(821));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var GatherTotal = function GatherTotal(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(823));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SingleSaleReport = function SingleSaleReport(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(825));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PackageSaleReport = function PackageSaleReport(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(824));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var GatherTakeOut = function GatherTakeOut(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(822));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Rank = function Rank(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(827));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var RankDineIn = function RankDineIn(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(828));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var RankTakeOut = function RankTakeOut(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(829));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var FoodType = function FoodType(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(820));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var AdditionSaleReport = function AdditionSaleReport(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(818));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Period = function Period(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(826));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Commission = function Commission(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(819));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var FoodGift = function FoodGift(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__(815));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var FoodBack = function FoodBack(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__(814));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var FreeOfChargeDetail = function FreeOfChargeDetail(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__(816));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var DiscountDetail = function DiscountDetail(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__(813));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var AntiSettlement = function AntiSettlement(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__(812));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var MidwarePage = function MidwarePage(r) {
  return __webpack_require__.e/* require.ensure */(5).then((function () {
    return r(__webpack_require__(840));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var MessageCenter = function MessageCenter(r) {
  return __webpack_require__.e/* require.ensure */(5).then((function () {
    return r(__webpack_require__(839));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var MemberTransfer = function MemberTransfer(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__(831));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var NoticeMemberTransfer = function NoticeMemberTransfer(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__(832));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CheckMemberTransfer = function CheckMemberTransfer(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__(830));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TestMemberTransfer = function TestMemberTransfer(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__(833));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TestMemberTransfer1 = function TestMemberTransfer1(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__(834));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]);
var routes = [{
  path: '/',
  name: 'Dashboard',
  component: Dashboard,
  meta: {
    title: '首页'
  }
}, {
  path: '/Menu/MenuHqList',
  name: 'MenuHqList',
  component: MenuHqList,
  meta: {
    cid: 'c_52pdqapy',
    title: '总部菜谱'
  }
}, {
  path: '/Menu/MenuHqList/MenuPublish',
  name: 'MenuPublish',
  component: MenuPublish,
  meta: {
    title: [{
      name: '总部菜谱',
      path: '/Menu/MenuHqList'
    }, {
      name: '菜谱发布'
    }]
  }
}, {
  path: '/Menu/MenuHqList/FoodEdit',
  name: 'FoodEdit',
  component: FoodEdit,
  meta: {
    cid: 'c_90yezxfp',
    title: [{
      name: '总部菜谱',
      path: '/Menu/MenuHqList'
    }, {
      name: '设置菜品'
    }]
  }
}, {
  path: '/Menu/MenuManage',
  name: 'MenuManage',
  component: MenuManage,
  meta: {
    cid: 'c_4cw1lzng',
    title: '菜谱发布管理'
  }
}, {
  path: '/Menu/MenuManage/MenuRepublish/:id',
  name: 'MenuRepublish',
  component: MenuRepublish,
  meta: {
    title: [{
      name: '菜谱发布管理',
      path: '/Menu/MenuManage'
    }, {
      name: '菜谱重新发布'
    }]
  }
}, {
  path: '/BusinessReport/BusiStatistics',
  name: 'BusiStatistics',
  component: BusiStatistics
}, {
  path: '/BusinessReport/PayType',
  name: 'PayType',
  component: PayType
}, {
  path: '/BusinessReport/InvoiceReport',
  name: 'InvoiceReport',
  component: InvoiceReport
}, {
  path: '/BusinessReport/BillDetail',
  name: 'BillDetail',
  component: BillDetail
}, {
  path: '/BusinessReport/SettlementStatistics',
  name: 'SettlementStatistics',
  component: SettlementStatistics
}, {
  path: '/BusinessReport/SettlementStatistics/SettlementHotelSummary',
  name: 'SettlementHotelSummary',
  component: SettlementHotelSummary,
  meta: {
    title: [{
      name: '结算信息统计表',
      path: '/BusinessReport/SettlementStatistics'
    }, {
      name: '门店汇总'
    }]
  }
}, {
  path: '/BusinessReport/SettlementStatistics/SettlementHotelSummary/SettlementHotelDetail',
  name: 'SettlementHotelDetail',
  component: SettlementHotelDetail,
  meta: {
    title: [{
      name: '结算信息统计表',
      path: '/BusinessReport/SettlementStatistics'
    }, {
      name: '结算信息门店汇总',
      path: '/BusinessReport/SettlementStatistics/SettlementHotelSummary',
      className: 'settlement-summary-breadcrumb'
    }, {
      name: '交易明细'
    }]
  }
}, {
  path: '/FoodReport/Gather',
  component: Gather,
  children: [{
    path: '',
    name: 'GatherTotal',
    component: GatherTotal
  }, {
    path: '/FoodReport/Gather/SingleSaleReport',
    name: 'SingleSaleReport',
    component: SingleSaleReport
  }, {
    path: '/FoodReport/Gather/PackageSaleReport',
    name: 'PackageSaleReport',
    component: PackageSaleReport
  }, {
    path: '/FoodReport/Gather/GatherTakeOut',
    name: 'GatherTakeOut',
    component: GatherTakeOut
  }]
}, {
  path: '/FoodReport/Rank',
  component: Rank,
  children: [{
    path: '',
    name: 'RankDineIn',
    component: RankDineIn
  }, {
    path: '/FoodReport/Rank/RankTakeOut',
    name: 'RankTakeOut',
    component: RankTakeOut
  }]
}, {
  path: '/FoodReport/FoodType',
  name: 'FoodType',
  component: FoodType
}, {
  path: '/FoodReport/AdditionSaleReport',
  name: 'AdditionSaleReport',
  component: AdditionSaleReport
}, {
  path: '/FoodReport/Period',
  name: 'Period',
  component: Period
}, {
  path: '/FoodReport/Commission',
  name: 'PercentAge',
  component: Commission
}, {
  path: '/CashierException/FoodGift',
  name: 'FoodGift',
  component: FoodGift
}, {
  path: '/CashierException/FoodBack',
  name: 'FoodBack',
  component: FoodBack
}, {
  path: '/CashierException/FreeOfChargeDetail',
  name: 'FreeOfChargeDetail',
  component: FreeOfChargeDetail
}, {
  path: '/CashierException/DiscountDetail',
  name: 'DiscountDetail',
  component: DiscountDetail
}, {
  path: '/CashierException/AntiSettlement',
  name: 'AntiSettlement',
  component: AntiSettlement
}, {
  path: '/Service/DownloadCenter',
  name: 'DownloadCenter',
  component: {
    template: '<comp-download-center/>'
  },
  meta: {
    cid: 'c_eco_m81yc73q'
  }
}, {
  path: '/Midware',
  name: 'Midware',
  component: MidwarePage
}, {
  path: '/MessageCenter',
  name: 'MessageCenter',
  component: MessageCenter,
  meta: {
    title: '消息中心',
    cid: 'c_mrqd6ax2'
  }
}, {
  path: '/Member/MemberTransfer',
  name: 'MemberTransfer',
  component: MemberTransfer
}, {
  path: '/Member/MemberTransfer/NoticeMemberTransfer',
  name: 'NoticeMemberTransfer',
  component: NoticeMemberTransfer
}, {
  path: '/Member/MemberTransfer/CheckMemberTransfer',
  name: 'CheckMemberTransfer',
  component: CheckMemberTransfer
}, {
  path: '/Member/MemberTransfer/TestMemberTransfer',
  name: 'TestMemberTransfer',
  component: TestMemberTransfer
}, {
  path: '/Member/MemberTransfer/TestMemberTransfer1',
  name: 'TestMemberTransfer1',
  component: TestMemberTransfer1
}];

if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_handleGrayByLocalstorage__["a" /* checkGrayItem */])('pingxin_fe_hq-static_feature')) {
  routes = routes.concat([{
    path: '/System/Download',
    name: 'Download',
    component: {
      template: '<comp-appoint-download />'
    }
  }]);
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]({
  routes: routes
}));

/***/ }),

/***/ 304:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(702)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(750),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(12))(139);

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getCookie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hasType; });
/* unused harmony export getTypeArray */
var getCookie = function getCookie(name) {
  var arr = void 0;
  var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) {
    return unescape(arr[2]);
  } else {
    return null;
  }
};

var agency = getCookie('AGENCY_TYPE');
var agencyList = agency ? agency.split('|') : [];

var hasType = function hasType(type) {
  if (agencyList.includes(type)) {
    return true;
  }
  return false;
};

var getTypeArray = function getTypeArray() {
  return agencyList;
};

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return (/.*SSID*/.test(document.cookie)
  );
});

/***/ }),

/***/ 313:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(712)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(760),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dealPromise */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);


var dealPromise = function dealPromise(promises, count) {
  var errorCount = 0;
  var thenHandler = function thenHandler(res) {
    return {
      res: res,
      status: 'success'
    };
  };
  var catchHandler = function catchHandler(err) {
    errorCount++;
    if (count && errorCount >= count) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('catch \u8D85\u8FC7\u4E86' + count + '\u6B21');
    } else {
      return {
        err: err,
        status: 'failed'
      };
    }
  };
  var transferedPromises = function transferedPromises(promises) {
    return promises.map(function (promise) {
      return promise.then(thenHandler).catch(catchHandler);
    });
  };
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(transferedPromises(promises));
};

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setGrayCookies; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_cookie__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dealPromise__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_gray__ = __webpack_require__(340);






var getGrayCookiesObj = function getGrayCookiesObj(grayList) {
  var cookies = {};
  grayList.forEach(function (item) {
    if (typeof item === 'string') {
      cookies[item] = {
        cookieName: item,
        cookieValue: 'Y',
        shouldReload: true
      };
    } else {
      cookies[item.testKey] = {
        cookieName: item.cookieName || item.testKey,
        cookieValue: item.cookieValue || 'Y',
        shouldReload: item.shouldReload === undefined || item.shouldReload
      };
    }
  });
  return cookies;
};
var grayCookies = getGrayCookiesObj(__WEBPACK_IMPORTED_MODULE_4__constants_gray__["a" /* grayList */]);

var setGrayCookies = function setGrayCookies(requestid) {
  if (grayCookies.length === 0 || !requestid) {
    return;
  }
  var testKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(grayCookies).join(",");
  getGrey(requestid, testKeys).then(function (res) {
    if (res && res.code === 200) {
      var shouldReload = false;
      delete res.code;
      delete res.msg;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(res).forEach(function (item) {
        if (grayCookies[item]) {
          shouldReload = verifyCookie(grayCookies[item], res[item]) || shouldReload;
        }
      });
      if (shouldReload === true) {
        window.location.reload();
      }
    }
  });
};
function getGrey(agencyid, testKeys) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/erpabtest-api-v2/batch/getTreatmentFe?agencyid=' + agencyid + '&testKeys=' + testKeys);
}
function verifyCookie(grayItem, res) {
  if (!grayItem.cookieName) {
    return false;
  }
  var shouldReload = false;
  if (res.strategy) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_cookie__["a" /* getCookie */])(grayItem.cookieName) !== grayItem.cookieValue) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_cookie__["b" /* setCookie */])(grayItem.cookieName, grayItem.cookieValue);
      shouldReload = true;
    }
  } else {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_cookie__["a" /* getCookie */])(grayItem.cookieName)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_cookie__["c" /* removeCookie */])(grayItem.cookieName);
      shouldReload = true;
    }
  }
  return shouldReload && grayItem.shouldReload;
}

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return grayList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_cookie__ = __webpack_require__(25);


var grayList = [{
  cookieName: "must-food-agency-gray",
  cookieValue: "y",
  testKey: "pingxin_apollo_must_food"
}, 'pingxin_food_name', {
  testKey: "pingxin_fe_show_history_menu",
  cookieValue: "y",
  cookieName: "pingxin_fe_show_history_menu"
}, {
  testKey: "pingxin_fe_service_center",
  cookieValue: "y",
  cookieName: "pingxin_fe_service_center"
}, 'pingxin_fe_hq-static_wct', "pingxin_fe_bugfix_food_method", {
  testKey: "pingxin_fe_system-download_trasnfer",
  cookieName: "mt_cloud",
  shouldReload: false
}, {
  testKey: "pingxin_fe_report_v1_9",
  cookieName: "report-web-gray"
}, "pingxin_fe_discount-optimization"];
var cookiesToBeRemoved = ['pingxin_pay_web_2_37', 'pingxin_pay_settle_busType', 'pingxin_report_1_5', 'pingxin_report_1_5_new_report', 'px_watch_storage', 'batch_upload_image', 'pingxin_apollo_publish_hotel_modify_price', 'pingxin_fe_dashboard_auth', "pingxin_apollo_search_food_in_menu"];
cookiesToBeRemoved.forEach(function (item) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_cookie__["c" /* removeCookie */])(item);
});

if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_cookie__["a" /* getCookie */])('feature_gray')) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_cookie__["c" /* removeCookie */])('feature_gray');
  window.location.reload();
}

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  AGENCY: {
    "101001": "/org/agency/brand",
    "105001": "/org/agency/template"
  },
  AUXI: {
    "401001": "/auxil/comment/repay",
    "402001": "/auxil/comment/free",
    "403001": "/auxil/comment/return",
    "404001": "/auxil/comment/given",
    "405001": "/auxil/comment/discount",
    "406001": "/auxil/comment/taste"
  },
  WCT_SHOW: {
    "100100101": "/wct/shows/wctCover",
    "100100201": "/wct/shows/hotelSorting",
    "100100301": "/wct/shows/loadHotelPicture"
  },
  WCT_QR: {
    "100300101": "/wct/qrcode",
    "100300201": "/wct/qrcode/table"
  },
  CRM_CARD: {
    "50200101": "/crm/card/make",
    "50200201": "/crm/card/delivery",
    "2050200101": "/crm/card/make",
    "2050200201": "/crm/card/delivery"
  },
  SDS_HOTEL: {
    "70110101": "/sds/hotel/report/goodsBatch",
    "70110201": "/sds/hotel/report/inoutAmount",
    "70110301": "/sds/hotel/report/inoutAmountDetail",
    "70110401": "/sds/hotel/report/profitLoss",
    "70110501": "/sds/hotel/report/stocktaking",
    "70110601": "/sds/hotel/report/supplier",
    "70110701": "/sds/hotel/report/orderDifference",
    "70110801": "/sds/hotel/report/procurement"
  },
  SDS_GROUP: {
    "80160101": "/sds/group/report/goodsBatch",
    "80160201": "/sds/group/report/inoutAmount",
    "80160301": "/sds/group/report/inoutAmountDetail",
    "80160401": "/sds/group/report/profitLoss",
    "80160501": "/sds/group/report/stocktaking",
    "80160601": "/sds/group/report/supplier"
  },
  SDS_GOODS: {
    "70180101": "/sds/group/goods",
    "701802": "/sds/group/category",
    "701803": "/sds/group/unit",
    "701804": "/sds/group/priceAgreement"
  },
  HOTEL_PURCHASE: {
    "701701": "/sds/hotel/purchase/order",
    "702201": "/sds/hotel/purchase/orderPanel"
  }
});

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_styles_default_css__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_styles_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_styles_default_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_theme_less__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_theme_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_styles_theme_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_styles_iconfont_css__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_styles_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_styles_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_styles_common_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_styles_common_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_styles_common_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_core_registerComponent__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_core_registerAjax__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_core_registerDirective__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_core_registerFilter__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_lxTracker__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_handleGrayByLocalstorage__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_echarts__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_track__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_isCRMUser__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__App_vue__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__router__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_subApp__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_vueErrorHandel__ = __webpack_require__(301);



















__WEBPACK_IMPORTED_MODULE_15_moment___default.a.locale('zh-cn');
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$moment = __WEBPACK_IMPORTED_MODULE_15_moment___default.a;


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$echarts = __WEBPACK_IMPORTED_MODULE_16_echarts___default.a;


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$track = __WEBPACK_IMPORTED_MODULE_17__util_track__["a" /* track */];


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$isCRMUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_isCRMUser__["a" /* default */])();

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$agency = {};





global.vm = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_20__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_19__App_vue___default.a }
});


var menus = __WEBPACK_IMPORTED_MODULE_22__util_subApp__["SUBAPP_MENU"];

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.navigateTo = function (params) {
  var path = params.path;

  var subApp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(menus).filter(function (item) {
    return path.indexOf(item) !== -1;
  })[0];
  if (menus[subApp] && menus[subApp].status !== 'loaded') {
    window.subAppUtils.loadSubApp(subApp);
  }
  this.$router.push(params);
};

window.subAppUtils = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_22__util_subApp__, {
  Vue: __WEBPACK_IMPORTED_MODULE_2_vue__["default"],
  state: global.vm.$store.state,
  from: 'hq-static'
});

__WEBPACK_IMPORTED_MODULE_20__router__["a" /* default */].afterEach(function (to, from) {
  if (from.name) {
    _hmt.push(['_trackPageview', '/#' + to.fullPath, window.location.origin]);
  } else {
    _hmt.push(['_trackPageview', '/#' + to.fullPath]);
  }

  var path = to.matched.length > 0 ? to.matched[to.matched.length - 1].path : '';
  window.Owl && window.Owl.config({
    pageUrl: '' + window.location.host + path
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_lxTracker__["a" /* lxCidTracker */])(to);
});


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.errorHandler = __WEBPACK_IMPORTED_MODULE_23__util_vueErrorHandel__["a" /* vueErrorHandel */];

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$lxBidTracker = __WEBPACK_IMPORTED_MODULE_13__util_lxTracker__["b" /* lxBidTracker */];

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$isRepeatGray = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_handleGrayByLocalstorage__["a" /* checkGrayItem */])('new-repeat-click');
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_isCRMUser__ = __webpack_require__(31);







/* harmony default export */ __webpack_exports__["a"] = ({
  getUnreadMessageInfo: function getUnreadMessageInfo(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var queryData, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              queryData = {
                isRead: '0',
                page: 1,
                rows: 3
              };
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/hq-web/notice/loadData', __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(queryData));

            case 3:
              res = _context.sent;

              commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["b" /* SET_UNREAD_MESSAGE_INFO */], res);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getUserAndHotelInfo: function getUserAndHotelInfo(_ref2) {
    var _this2 = this;

    var commit = _ref2.commit,
        state = _ref2.state;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var isCRM, res, _res;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              isCRM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_isCRMUser__["a" /* default */])();

              if (!isCRM) {
                _context2.next = 9;
                break;
              }

              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/hq-agency/user/current');

            case 4:
              res = _context2.sent;

              commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* SET_USER_AND_HOTEL_INFO */], {
                user: res.data
              });
              return _context2.abrupt("return", res);

            case 9:
              _context2.next = 11;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/hq-web/reportCenter/userInfo');

            case 11:
              _res = _context2.sent;

              commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* SET_USER_AND_HOTEL_INFO */], {
                user: _res.data
              });
              return _context2.abrupt("return", _res);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getOrgTree: function getOrgTree(_ref3) {
    var _this3 = this;

    var commit = _ref3.commit,
        state = _ref3.state;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var isCRM, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              isCRM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_isCRMUser__["a" /* default */])();
              res = null;

              if (!isCRM) {
                _context3.next = 8;
                break;
              }

              _context3.next = 5;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/hq-agency/user/agency_tree');

            case 5:
              res = _context3.sent;
              _context3.next = 11;
              break;

            case 8:
              _context3.next = 10;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/hq-web/reportCenter/treeLoad', __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify({ type: '1,2,3,4' }));

            case 10:
              res = _context3.sent;

            case 11:
              commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["c" /* SET_ORG_TREE */], res.data);
              return _context3.abrupt("return", res);

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  queryCrmUpdateClose: function queryCrmUpdateClose(_ref4) {
    var _this4 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var isCRM, result;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              isCRM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_isCRMUser__["a" /* default */])();

              if (!isCRM) {
                _context4.next = 6;
                break;
              }

              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/hq-web/crm/member/check-crm-upgrade-close');

            case 4:
              result = _context4.sent;

              if (result && result.code === '200') {
                commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["d" /* GET_CRM_UPDATE_CLOSE */], result.data);
              }

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(191);


var _SET_USER_AND_HOTEL_I;



/* harmony default export */ __webpack_exports__["a"] = (_SET_USER_AND_HOTEL_I = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_USER_AND_HOTEL_I, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SET_USER_AND_HOTEL_INFO */], function (state, info) {
  state.userInfo = info.user;
  if (info.user && info.user.username) {
    state.userInfo.userName = info.user.username;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_USER_AND_HOTEL_I, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* SET_UNREAD_MESSAGE_INFO */], function (state, messages) {
  state.unreadMessageInfo = messages;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_USER_AND_HOTEL_I, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* SET_UNREAD_MESSAGE_INFO */], function (state, messages) {
  state.unreadMessageInfo = messages;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_USER_AND_HOTEL_I, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* SET_ORG_TREE */], function (state, messages) {
  state.orgTree = messages;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_USER_AND_HOTEL_I, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* GET_CRM_UPDATE_CLOSE */], function (state, status) {
  state.crmUpdateClose = status;
}), _SET_USER_AND_HOTEL_I);

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ui_NavBar_NavBar_vue__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ui_NavBar_NavBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ui_NavBar_NavBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ui_SideNav_SideNav_vue__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ui_SideNav_SideNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ui_SideNav_SideNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ui_SideNav_SideNavCRM_vue__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ui_SideNav_SideNavCRM_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_ui_SideNav_SideNavCRM_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ui_MessageNav_MessageNav_vue__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ui_MessageNav_MessageNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_ui_MessageNav_MessageNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ui_Guide_Guide_vue__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ui_Guide_Guide_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_ui_Guide_Guide_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ui_UpdateName_UpdateName_vue__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ui_UpdateName_UpdateName_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_ui_UpdateName_UpdateName_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_isCRMUser__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_menu_crm__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_getRouterConf__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_org_guide_png__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_org_guide_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_org_guide_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_lxTracker__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_setGrayCookies__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_handleGrayByLocalstorage__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_cookie__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_js_cookie__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_js_cookie__);


























var originalCookie = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_cookie__["a" /* getCookie */])("SSID");

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    NavBar: __WEBPACK_IMPORTED_MODULE_6__components_ui_NavBar_NavBar_vue___default.a,
    SideNav: __WEBPACK_IMPORTED_MODULE_7__components_ui_SideNav_SideNav_vue___default.a,
    SideNavCRM: __WEBPACK_IMPORTED_MODULE_8__components_ui_SideNav_SideNavCRM_vue___default.a,
    MessageNav: __WEBPACK_IMPORTED_MODULE_9__components_ui_MessageNav_MessageNav_vue___default.a,
    Guide: __WEBPACK_IMPORTED_MODULE_10__components_ui_Guide_Guide_vue___default.a,
    UpdateName: __WEBPACK_IMPORTED_MODULE_11__components_ui_UpdateName_UpdateName_vue___default.a
  },
  created: function created() {
    var _this = this;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_handleGrayByLocalstorage__["a" /* checkGrayItem */])('pingxin_fe_irs-static_crm_update_close')) {
      this.queryCrmUpdateClose();
    }
    this.$axios.all([this.getOrgTree(), this.getUserAndHotelInfo(), this.checkHqPos(), this.getMenuList(), window.getComp('hqStatic')]).then(this.$axios.spread(function (orgTree, userAndHotelInfo, isHqPos, menu) {
      _this.getAllGray();
      window.registerComponent(__WEBPACK_IMPORTED_MODULE_4_vue__["default"]);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_setGrayCookies__["a" /* setGrayCookies */])(_this.userInfo.agencyId);
      _this.$agency.isHQ = true;
      if (__WEBPACK_IMPORTED_MODULE_20_js_cookie___default.a.get('OLDLOGINFROMHQ')) {
        _this.getGrey(_this.userInfo).then(function (greyInfo) {
          if (greyInfo && greyInfo.code === 200 && greyInfo.strategy) {

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_lxTracker__["a" /* lxCidTracker */])({ meta: { cid: 'c_eco_qzbcad7g' } });
            _this.showLoginGuide = true;
          }
        });
      }
      _this.getReportGray('pingxin_fe_report-web_1_8');
      _this.$axios.all([_this.queryRepeatName(), _this.getNameGray(_this.userInfo)]).then(_this.$axios.spread(function (nameRepeat, nameGray) {
        if (nameGray.code === 200 && nameGray.strategy && nameRepeat.code === 200 && nameRepeat.data) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_lxTracker__["a" /* lxCidTracker */])({ meta: { cid: 'c_eco_gqa4onyd' } });
          _this.showUpdateName = true;
        }
      }));

      _this.menus = isHqPos && isHqPos.containCount !== 0 && _this.isCRMUser || _this.userInfo && _this.userInfo.nativeForAndroid === true ? __WEBPACK_IMPORTED_MODULE_13__constants_menu_crm__["a" /* default */].filter(function (item) {
        return ['60', '110', '130', '140'].indexOf(item.id) === -1;
      }) : __WEBPACK_IMPORTED_MODULE_13__constants_menu_crm__["a" /* default */];
      _this.isReady = true;
      if (_this.userInfo.firstLogin === 1 || localStorage.getItem('crmFirstLogin')) {
        _this.isImgShow = true;
        localStorage.removeItem('crmFirstLogin');
      }
      if (_this.isCRMUser) {
        var orgLength = orgTree.data.filter(function (item) {
          return item.type === 3;
        }).length;
        localStorage.setItem('orgLength', orgLength);
        localStorage.setItem('isAndroid', _this.userInfo && _this.userInfo.nativeForAndroid);
        if (isHqPos === null) {
          localStorage.setItem('isHqPos', 0);
        } else if (isHqPos.containCount === 0) {
          localStorage.setItem('isHqPos', 0);
        } else if (isHqPos.containCount === orgLength) {
          localStorage.setItem('isHqPos', 2);
        } else {
          localStorage.setItem('isHqPos', 1);
        }
        var hasShowReportGuideIds = __WEBPACK_IMPORTED_MODULE_20_js_cookie___default.a.get('hasShowReportGuideIds');
        if (hasShowReportGuideIds) {
          hasShowReportGuideIds = JSON.parse(hasShowReportGuideIds);
        } else {
          hasShowReportGuideIds = [];
        }
        _this.showReportGuide = hasShowReportGuideIds.indexOf(_this.userInfo.userId) === -1 && isHqPos !== null && isHqPos.containCount !== 0 && menu && menu.menuList && menu.menuList.report;
      }
      _this.navigateTo({
        path: location.hash.substring(1)
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_lxTracker__["a" /* lxCidTracker */])(_this.$route);

      if ((userAndHotelInfo.data.type === 1 || userAndHotelInfo.data.type === 6) && userAndHotelInfo.data.userType === 0) {
        _this.$axios.get('/hq-agency/agreement/agency/valid').then(function (res) {
          if (res.code === 200) {
            if (!res.data) {
              _this.protocol.visible = true;
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_lxTracker__["a" /* lxCidTracker */])({ meta: { cid: 'c_eco_59t52oko' } });
              LXAnalytics && LXAnalytics('moduleView', 'b_eco_fjbfbmxi_mv');
            }
          } else {
            _this.$message.error("网络异常，请稍后再试");
          }
        });
      }

      _this.getCRMSplit(_this.userInfo).then(function (res) {
        if (res.code === 200) {
          if (res.data === true) {
            __WEBPACK_IMPORTED_MODULE_20_js_cookie___default.a.set('crm-3', 'Y', { expires: 3650 });
          } else {
            __WEBPACK_IMPORTED_MODULE_20_js_cookie___default.a.remove('crm-3');
          }
        }
      });

      __WEBPACK_IMPORTED_MODULE_20_js_cookie___default.a.set('fe-crm-name', 'Y', { expires: 3650 });
      __WEBPACK_IMPORTED_MODULE_20_js_cookie___default.a.remove('fe-repeat-click', 'Y', { expires: 3650 });
      _this.getRepeatGray(_this.userInfo).then(function (res) {
        if (res.code === 200 && res.strategy) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_handleGrayByLocalstorage__["b" /* setGrayItem */])('new-repeat-click');
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_handleGrayByLocalstorage__["c" /* removeGrayItem */])('new-repeat-click');
        }
      });
    }));
  },
  mounted: function mounted() {
    if (window.addEventListener) {
      window.addEventListener('storage', this.verifyCookie);
    } else if (window.attachEvent) {
      window.attachEvent('storage', this.verifyCookie);
    }
  },
  destroyed: function destroyed() {
    if (window.removeEventListener) {
      window.removeEventListener('storage', this.verifyCookie);
    } else if (window.detachEvent) {
      window.detachEvent('storage', this.verifyCookie);
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapState"])(['userInfo'])),
  data: function data() {
    return {
      componentName: ['PayMethod', 'MenuManage', 'geto-duty'],
      isReady: false,
      isCRMUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_isCRMUser__["a" /* default */])(),
      isShowSys: true,
      menus: [],
      OrgGuideImg: __WEBPACK_IMPORTED_MODULE_15__assets_images_org_guide_png___default.a,
      isImgShow: false,
      breadCrumbs: [{
        name: '首页'
      }],
      showReportGuide: false,
      showLoginGuide: false,
      protocol: {
        visible: false
      },
      showUpdateName: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapActions"])(['getOrgTree', 'getUserAndHotelInfo', 'queryCrmUpdateClose']), {
    getAllGray: function getAllGray() {
      var grayList = ['pingxin_fe_hq-static_feature', 'pingxin_fe_hq-static_hotfix', 'pingxin_fe_hq-static_food-publish', 'pingxin_fe_irs-static_crm_update_close', 'pingxin_diancan_bsj_audit_to_c'];
      var testKeys = grayList.join(',');
      var url = '/erpabtest-api-v2/batch/getTreatmentFe?agencyid=' + this.userInfo.agencyId + '&testKeys=' + testKeys;
      this.$axios.get(url).then(function (res) {
        if (res && res.code === 200) {
          grayList.forEach(function (grayKey) {
            if (res[grayKey] && res[grayKey].strategy) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_handleGrayByLocalstorage__["b" /* setGrayItem */])(grayKey, 'Y');
            } else {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_handleGrayByLocalstorage__["c" /* removeGrayItem */])(grayKey);
            }
          });
        }
      });
    },
    getGrey: function getGrey(userInfo) {
      if (!userInfo) {
        return;
      }
      return this.$axios.get('/erpabtest-api/getTreatmentFe?agencyid=' + userInfo.agencyId + '&testKey=pingxin_fe_loginRedirect');
    },
    getRepeatGray: function getRepeatGray(userInfo) {
      if (!userInfo) {
        return;
      }
      return this.$axios.get('/erpabtest-api/getTreatmentFe?agencyid=' + userInfo.agencyId + '&testKey=pingxin_fe_repeatClick');
    },
    getNameGray: function getNameGray(userInfo) {
      if (!userInfo) {
        return;
      }
      return this.$axios.get('/erpabtest-api/getTreatmentFe?agencyid=' + userInfo.agencyId + '&testKey=pingxin_agency_repeat_username_key');
    },
    queryRepeatName: function queryRepeatName() {
      return this.$axios.get('/metis-user-web/user/whiteUser');
    },
    getCRMSplit: function getCRMSplit(userInfo) {
      if (!userInfo) {
        return;
      }
      return this.$axios.get('/crm-api/eos-api-web/split/check-split?agencyId=' + userInfo.agencyId);
    },
    getReportGray: function getReportGray(testKey) {
      var strategy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Y';

      if (!this.userInfo) {
        return;
      }
      var params = {
        agencyid: this.userInfo.agencyId,
        testKeys: testKey
      };
      return this.$axios.get('/erpabtest-api-v2/batch/getTreatmentFe', { params: params }).then(function (res) {
        if (res.code === 200 && res[testKey] && res[testKey]['strategy']) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_handleGrayByLocalstorage__["b" /* setGrayItem */])(testKey, strategy);
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_handleGrayByLocalstorage__["c" /* removeGrayItem */])(testKey);
        }
      });
    },
    getTitle: function getTitle() {
      var title = this.$route.meta.title;

      if (title && typeof title === 'string') {
        return [{ name: title }];
      } else if (title && (typeof title === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(title)) === 'object') {
        return title;
      } else {
        if (this.$route.path === '/Midware' || this.$route.path === '/') {
          return;
        }
        return [{ name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_getRouterConf__["a" /* default */])(this.$route.path)[1].name }];
      }
    },
    getMenuList: function getMenuList() {
      if (!this.isCRMUser) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }
      if (!localStorage.getItem('menuList')) {
        return this.$axios.get('/hq-agency/user/menu').then(function (menu) {
          if (menu.code === 200) {
            var menuList = {};
            menu.data.forEach(function (item) {
              menuList[item.systemCode] = item.menu.map(function (one) {
                return one.id;
              });
            });
            localStorage.setItem('menu', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(menu.data));
            localStorage.setItem('menuList', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(menuList));
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({
              menu: menu.data,
              menuList: menuList
            });
          }
        });
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({
          menu: JSON.parse(localStorage.getItem('menu')),
          menuList: JSON.parse(localStorage.getItem('menuList'))
        });
      }
    },
    hideOrgImg: function hideOrgImg() {
      this.isImgShow = false;
    },
    checkHqPos: function checkHqPos() {
      var queryParams = {
        queryLists: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[{
          operation: 5,
          version: '2.30.5'
        }], [{
          operation: 3,
          version: '2.33'
        }]])
      };
      return this.$axios.post('/hq-agency/agency/check_pos_version', this.$qs.stringify(queryParams)).then(function (res) {
        if (res.code === 200) {
          return res.data;
        } else {
          return null;
        }
      });
    },
    modifyName: function modifyName() {
      console.log('modifyName', this.$refs);
      this.$refs.updateNameDialog.show();
    },
    verifyCookie: function verifyCookie() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_cookie__["a" /* getCookie */])("SSID") !== originalCookie) {
        window.location.href = "/account-web/account.html";
      }
    }
  }),
  watch: {
    '$route': function $route() {
      this.breadCrumbs = this.getTitle();
    }
  }
});

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AgencyTreeCore_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AgencyTreeCore_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AgencyTreeCore_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isCRMUser_js__ = __webpack_require__(31);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'popover',
  components: {
    AgencyTreeCore: __WEBPACK_IMPORTED_MODULE_0__AgencyTreeCore_vue___default.a
  },
  inheritAttrs: false,
  data: function data() {
    return {
      visible: false,
      inputValue: '',
      isCRMUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_isCRMUser_js__["a" /* default */])()
    };
  },

  methods: {
    handleClickNode: function handleClickNode(agency) {
      if (agency) {
        if (!this.isCRMUser && agency.type === 4 && agency.disable === false || agency.type === 3 && this.isCRMUser) {
          this.inputValue = '' + agency.name;
          this.visible = false;
          this.$emit('checkAgencyLeaves', [agency]);
        }
      } else {
        this.inputValue = '';
      }
    },
    handleCheckedChange: function handleCheckedChange(agencyLeaves) {
      var _this = this;

      var selectedAgencies = [];
      agencyLeaves.forEach(function (item) {
        if (_this.isCRMUser) {
          item.hotelId && selectedAgencies.push(item);
        } else {
          item.hotelId && item.disable === false && selectedAgencies.push(item);
        }
      });
      this.$emit('checkAgencyLeaves', selectedAgencies);
      var checkedNum = selectedAgencies.length;
      switch (checkedNum) {
        case 0:
          this.inputValue = '';
          break;
        case 1:
          this.inputValue = selectedAgencies[0].name;
          break;
        default:
          this.inputValue = '\u5DF2\u9009\u62E9 ' + checkedNum + ' \u5BB6\u95E8\u5E97';
      }
    },
    setAgency: function setAgency(agencies) {
      this.$refs.treeCore.setAgency(agencies);
    },
    setAgencyByHotelId: function setAgencyByHotelId(hotelId) {
      this.$refs.treeCore.setAgencyByHotelId(hotelId);
    },
    selectAll: function selectAll() {
      var _$refs$treeCore$getDa = this.$refs.treeCore.getData(),
          data = _$refs$treeCore$getDa.data,
          tree = _$refs$treeCore$getDa.tree;

      this.$refs.treeCore.setAgency([tree[0].id]);
      this.handleCheckedChange(data);
    }
  }
});

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isCRMUser__ = __webpack_require__(31);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['placeholder'],
  data: function data() {
    return {
      checkable: this.$attrs.checkable === undefined || this.$attrs.checkable,
      filterText: '',
      currentKeys: [],
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name',
        disabled: 'disable'
      },
      defaultCheckedKeys: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])(['orgTree'])),
  created: function created() {
    this.initTree(this.orgTree);
  },

  methods: {
    initTree: function initTree(agencyList) {
      var root = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_isCRMUser__["a" /* default */])() ? agencyList[0] : agencyList[agencyList.length - 1];
      root.children = this.findChild(agencyList, root.id);
      this.treeData = [root];
    },
    findChild: function findChild(list, rootId) {
      var map = {};
      list.forEach(function (item) {
        item.children = [];
        map[item.id] = item;
      });
      list.forEach(function (item) {
        if (map[item.pid]) {
          map[item.pid].children.push(item);
        }
      });
      var ret = [];
      for (var i in map) {
        if (map[i].pid === rootId) {
          ret.push(map[i]);
        }
      }
      return ret;
    },
    clearFilter: function clearFilter() {
      this.filterText = '';
    },
    filterNode: function filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    handleCheck: function handleCheck(data, _ref) {
      var checkedKeys = _ref.checkedKeys,
          checkedNodes = _ref.checkedNodes;

      var leafNodes = checkedNodes.filter(function (node) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_isCRMUser__["a" /* default */])()) {
          return node.type === 3;
        } else {
          return node.children && node.children.length === 0 && node.type === 4;
        }
      });
      this.currentKeys = leafNodes;
      this.$emit('checkedChange', leafNodes);
    },
    handleNodeClick: function handleNodeClick(data) {
      this.$emit('node-text-click', data);
      if (!this.checkable) {
        this.$emit('nodeClick', data);
      }
    },
    setAgency: function setAgency(agencies) {
      if (this.checkable) {
        agencies = agencies || [];
        this.$refs.tree.setCheckedKeys(agencies);
      } else {
        if (agencies === undefined) {
          this.$emit('nodeClick');
          this.$refs.tree.store.currentNode = null;
        } else {
          var curNode = this.$refs.tree.store.nodesMap[agencies].data;
          this.$emit('nodeClick', curNode);
        }
      }
    },
    setAgencyByHotelId: function setAgencyByHotelId(hotelId) {
      var agencies = this.getIdByHotelId(hotelId);
      if (this.checkable) {
        agencies = agencies || [];
        this.$refs.tree.setCheckedKeys(agencies);
      } else {
        if (agencies === undefined) {
          this.$emit('nodeClick');
          this.$refs.tree.store.currentNode = null;
        } else {
          var curNode = this.$refs.tree.store.nodesMap[agencies].data;
          this.$emit('nodeClick', curNode);
        }
      }
    },
    getData: function getData() {
      return {
        data: this.orgTree,
        tree: this.treeData
      };
    },
    getIdByHotelId: function getIdByHotelId(hotelId) {
      var item = this.orgTree.filter(function (item) {
        return +item.hotelId === +hotelId;
      });
      if (item.length > 0) {
        return item[0].id;
      } else {
        return undefined;
      }
    }
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  }
});

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__agencyUtils__ = __webpack_require__(186);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'treeData': {
      type: Array
    },
    'isCRMUser': {
      type: Boolean,
      default: true
    },
    'hasFilter': {
      type: Boolean,
      default: true
    },
    'filterNodeMethod': {
      type: Function,
      default: function _default(item, filterText) {
        return true;
      }
    },
    'content-height': {
      type: Number,
      default: 360
    }
  },
  name: 'popover',
  data: function data() {
    return {
      visible: false,
      inputValue: '',
      filterText: '',
      height: 0,
      visibleData: []
    };
  },
  mounted: function mounted() {
    var that = this;
    this.$el.getElementsByClassName('el-tree')[0].addEventListener('scroll', function () {
      if (/macintosh/i.test(navigator.userAgent)) {
        setTimeout(function () {
          that.update();
        }, 0);
      } else {
        that.update();
      }
    });
    this.update();
  },
  created: function created() {
    this.caclHeight();
  },

  methods: {
    caclHeight: function caclHeight() {
      this.height = this.treeData.length * 26;
    },
    handleExpand: function handleExpand(val) {
      var count = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__agencyUtils__["d" /* getChildrenLength */])(val);
      var startIndex = val.index;
      this.treeData[startIndex].expanded = !val.expanded;
      if (val.expanded) {
        this.height = this.height + count * 26;
      } else {
        this.height = this.height - count * 26;
      }
      this.update();
    },
    handleCheckChange: function handleCheckChange(cData, cNewCheckStatus) {
      var _this = this;

      var items = Object.prototype.toString.call(cData) === '[object Array]' ? cData : [cData];
      items.forEach(function (val) {
        var checkStatus = val.checkStatus;
        var oCheckStatus = checkStatus.checked;
        var nCheckStatus = cNewCheckStatus === true ? 2 : checkStatus.checked === 2 ? 0 : 2;

        _this._checkParentChecked(val, oCheckStatus, nCheckStatus);

        var index = val.index;
        for (var i = index, length = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__agencyUtils__["d" /* getChildrenLength */])(val) + index; i <= length; i++) {
          _this.treeData[i].checkStatus.checked = nCheckStatus;
          _this.treeData[i].checkStatus.childChecked = nCheckStatus === 0 ? [_this.treeData[i].children.length, 0, 0] : [0, 0, _this.treeData[i].children.length];
        }
      });
      this.update();

      var selectedAgencies = [];
      this.treeData.forEach(function (item) {
        var id = item.id;
        var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__agencyUtils__["e" /* getDataById */])(_this.treeData, id);
        if (data && data.checkStatus.checked === 2) {
          if (_this.isCRMUser) {
            item.hotelId && selectedAgencies.push(item);
          } else {
            item.hotelId && item.disable === false && selectedAgencies.push(item);
          }
        }
      });
      this.$emit('checkAgencyLeaves', selectedAgencies);
    },
    _checkParentChecked: function _checkParentChecked(item, oCheckStatus, nCheckStatus) {
      if (oCheckStatus === nCheckStatus) {
        return;
      }
      var parentItem = this.treeData[item.pIndex];
      if (!parentItem) {
        return;
      }
      var parentCheckStatus = parentItem.checkStatus;
      var pOCheckStatus = parentCheckStatus.checked;
      var pNCheckStatus = null;

      parentCheckStatus.childChecked[oCheckStatus]--;
      parentCheckStatus.childChecked[nCheckStatus]++;

      if (parentCheckStatus.childChecked[0] === parentCheckStatus.childLength) {
        pNCheckStatus = 0;
        parentCheckStatus.checked = 0;
      } else if (parentCheckStatus.childChecked[2] === parentCheckStatus.childLength) {
        pNCheckStatus = 2;
        parentCheckStatus.checked = 2;
      } else {
        pNCheckStatus = 1;
        parentCheckStatus.checked = 1;
      }
      this._checkParentChecked(parentItem, pOCheckStatus, pNCheckStatus);
    },
    handleFilter: function handleFilter() {

      var parentMap = {};
      var count = 0;
      for (var i = this.treeData.length - 1; i >= 0; i--) {
        var item = this.treeData[i];
        var isFilter = false;
        if (parentMap[item.index] === true) {
          isFilter = true;
          item.visible = true;
          count++;
        } else {
          isFilter = this.filterNodeMethod(item, this.filterText);
          if (isFilter) {
            count++;
          }
          item.visible = isFilter;
        }
        if (isFilter && this.treeData[item.pIndex]) {
          parentMap[item.pIndex] = true;
        }
      }
      this.height = count * 26;
      this.update();
    },
    selectAll: function selectAll() {
      var onlyHotels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (onlyHotels) {
        var ids = [];
        this.treeData.forEach(function (item) {
          if (item.type === 3) {
            ids.push(item.id);
          }
        });
        this.setAgency(ids);
      } else {
        this.setAgency([this.treeData[0].id]);
      }
    },
    handleClickNode: function handleClickNode(agency) {
      if (agency) {
        if (!this.isCRMUser && agency.type === 4 && agency.disable === false || agency.type === 3 && this.isCRMUser) {
          this.inputValue = '' + agency.name;
          this.visible = false;
          this.$emit('checkAgencyLeaves', [agency]);
        }
      } else {
        this.inputValue = '';
      }
    },
    update: function update() {
      var scrollTop = this.$el.getElementsByClassName('el-tree')[0].scrollTop;
      var count = scrollTop ? Math.floor(scrollTop / 26) : -1;
      var showIndex = count + 1;
      var leftHeight = scrollTop - count * 26;

      for (var i = 0; i < count; i++) {
        if (this.treeData[i].expanded === false) {
          count += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__agencyUtils__["d" /* getChildrenLength */])(this.treeData[i]);
        }
      }
      var vData = [];
      for (var _i = count + 1; _i < this.treeData.length; _i++) {
        if (vData.length === 50) {
          break;
        }
        if (this.treeData[_i].visible === false) {
          continue;
        }
        var id = this.treeData[_i].id;
        this.treeData[_i].paddingTop = 26 * showIndex++ - (26 - leftHeight);
        var checkStatus = this.treeData[_i].checkStatus.checked;
        this.treeData[_i].checkClass = checkStatus === 0 ? '' : checkStatus === 2 ? 'is-checked' : 'is-indeterminate';
        vData.push(this.treeData[_i]);
        if (this.treeData[_i].expanded === false) {
          _i += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__agencyUtils__["d" /* getChildrenLength */])(this.treeData[_i]);
        }
      }
      if (vData.length !== 0 && vData[vData.length - 1].paddingTop + 26 > this.height) {
        this.height = vData[vData.length - 1].paddingTop + 26;
      }
      this.visibleData = vData;
    },
    setAgency: function setAgency(agencies) {
      var _this2 = this;

      this.treeData.forEach(function (item) {
        item.checkStatus.checked = 0;
        item.checkStatus.childChecked = [item.checkStatus.childLength, 0, 0];
      });
      var datas = [];
      agencies.forEach(function (id) {
        var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__agencyUtils__["e" /* getDataById */])(_this2.treeData, id);
        data && datas.push(data);
      });
      this.handleCheckChange(datas, true);
    },
    setAgencyByHotelId: function setAgencyByHotelId(hotelId) {
      var agencies = this.getIdByHotelId(hotelId);
      if (this.checkable) {
        agencies = agencies || [];
        this.$refs.tree.setCheckedKeys(agencies);
      } else {
        if (agencies === undefined) {
          this.$emit('nodeClick');
          this.$refs.tree.store.currentNode = null;
        } else {
          var curNode = this.$refs.tree.store.nodesMap[agencies].data;
          this.$emit('nodeClick', curNode);
        }
      }
    },
    getIdByHotelId: function getIdByHotelId(hotelId) {
      var item = this.orgTree.filter(function (item) {
        return +item.hotelId === +hotelId;
      });
      if (item.length > 0) {
        return item[0].id;
      } else {
        return undefined;
      }
    },
    clearFilter: function clearFilter() {
      this.filterText = '';
      this.handleFilter();
    },
    handleShowMore: function handleShowMore() {
      this.$emit('showMore');
    }
  }
});

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AgencyTreeCore__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AgencyTreeCore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AgencyTreeCore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__agencyUtils__ = __webpack_require__(186);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['dataSource'],
  components: {
    AgencyTreeCore: __WEBPACK_IMPORTED_MODULE_1__AgencyTreeCore___default.a
  },
  data: function data() {
    return {
      visible: false,
      checkable: this.$attrs.checkable === undefined || this.$attrs.checkable,
      selectList: []
    };
  },
  created: function created() {
    var orgTree = this.dataSource.map(function (item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
    });
    var root = orgTree[0];
    root.children = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__agencyUtils__["a" /* findChild */])(orgTree, root.id);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__agencyUtils__["b" /* init */])();
    this.treeData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__agencyUtils__["c" /* flatern */])(root, 0, -1);
  },

  methods: {
    handleFilterNode: function handleFilterNode(data, filterText) {
      return data.name.indexOf(filterText) !== -1;
    },
    handleDelSelect: function handleDelSelect(index) {
      this.selectList.splice(index, 1);
      var ids = this.selectList.map(function (item) {
        return item.id;
      });
      this.$refs.tree.setAgency(ids);
      this.$emit('checkAgencyLeaves', this.selectList);
    },
    handleClear: function handleClear() {
      var waitIds = [];
      this.treeData.forEach(function (item) {
        if (item.type === 3 && item.checkStatus.checked === 2) {
          waitIds.push(item.id);
        }
      });
      var alreadyIds = this.selectList.map(function (item) {
        return item.id;
      });
      var ret = [];
      waitIds.forEach(function (waitId) {
        if (alreadyIds.indexOf(waitId) === -1) {
          ret.push(waitId);
        }
      });
      this.$refs.tree.setAgency(ret);
      this.selectList = [];
      this.$emit('checkAgencyLeaves', this.selectList);
    },
    handleSelect: function handleSelect(e) {
      var data = this.treeData.filter(function (item) {
        return item.type === 3 && item.checkStatus.checked === 2;
      });
      if (data.length === 0) {
        this.$message.warning('请选择门店');
        return false;
      }
      this.selectList = data.filter(function (item) {
        return item.type === 3 && item.checkStatus.checked === 2;
      });
      this.$emit('checkAgencyLeaves', this.selectList);
      return false;
    },
    handleNodeClick: function handleNodeClick(agency) {
      this.selectList = [agency];
    },
    setAgency: function setAgency(agencies) {
      this.$refs.tree.setAgency(agencies);
      this.selectList = this.treeData.filter(function (item) {
        return item.type === 3 && item.checkStatus.checked === 2;
      });
      this.$emit('checkAgencyLeaves', this.selectList);
    }
  }
});

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_list_png__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_list_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_list_png__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CwCollapse',

  componentName: 'CwCollapse',

  props: {
    text: {
      type: [String, Array],
      'default': function _default() {
        return ['更多筛选', '收起筛选'];
      }
    },
    'default-open': {
      type: Boolean,
      default: false
    },
    'slot-header': ''
  },
  methods: {
    handleShowMore: function handleShowMore() {
      this.showMore = !this.showMore;
      if (this.showMore) {
        this.$emit('showMore');
        if (_hmt) {
          _hmt.push(['_trackEvent', location.hash.substring(1), '展开查询条件']);
        }
      }
    }
  },
  computed: {
    collapseText: function collapseText() {
      if (typeof this.$props.text === 'string') {
        var matchArr = this.$props.text.match(/(.*)[,|，|、| ](.*)/);
        if (matchArr) {
          return [matchArr[1], matchArr[2]];
        } else {
          return [this.$props.text, this.$props.text];
        }
      } else {
        return this.$props.text;
      }
    }
  },
  data: function data() {
    return {
      showMore: this.$props.defaultOpen || false,
      title: this.$props.slotHeader,
      listUrl: __WEBPACK_IMPORTED_MODULE_0__assets_images_list_png___default.a
    };
  }
});

/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    items: {
      type: Array,
      'default': function _default() {
        return [{
          text: '今天',
          values: [__WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('days').valueOf(), __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('days').valueOf() + 1]
        }, {
          text: '7天',
          values: [__WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('days').subtract(6, 'days').valueOf(), __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('days').valueOf() + 1]
        }, {
          text: '15天',
          values: [__WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('days').subtract(14, 'days').valueOf(), __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('days').valueOf() + 1]
        }, {
          text: '30天',
          values: [__WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('days').subtract(29, 'days').valueOf(), __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('days').valueOf() + 1]
        }];
      }
    },
    onClick: {
      type: Function
    },
    hasDefault: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      active: this.hasDefault ? 0 : ''
    };
  },

  methods: {
    handleItemClick: function handleItemClick(index) {
      if (this.items[index].active) {
        return;
      }
      this.active = index;
      this.onClick(this.items[this.active].values);
    },
    setActive: function setActive(index) {
      if (index) {
        this.active = index;
      }
      this.active = null;
    }
  }
});

/***/ }),

/***/ 355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['desc'],
  data: function data() {
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.desc) === 'object' && this.desc.constructor === Array) {
      return {
        descText: '',
        descTexts: this.desc
      };
    }
    return {
      descText: this.desc,
      descTexts: null
    };
  }
});

/***/ }),

/***/ 356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'tip': {
      type: [String, Array]
    },
    'iconClass': {
      type: String,
      default: 'iconfont icon-shuoming'
    },
    'placement': {
      type: String,
      default: 'right-start'
    }
  },
  data: function data() {
    return {
      tips: []
    };
  },
  created: function created() {
    if (typeof this.tip === "string") {
      this.tips.push(this.tip);
    } else {
      this.tips = this.tip;
    }
  }
});

/***/ }),

/***/ 357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_hq_guide_step_1_png__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_hq_guide_step_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_hq_guide_step_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_hq_guide_step_2_png__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_hq_guide_step_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_hq_guide_step_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['userInfo'],
  data: function data() {
    return {
      hqGuideStep1: __WEBPACK_IMPORTED_MODULE_0__assets_images_hq_guide_step_1_png___default.a,
      hqGuideStep2: __WEBPACK_IMPORTED_MODULE_1__assets_images_hq_guide_step_2_png___default.a,
      guideStep: 1
    };
  },

  methods: {
    handleNext: function handleNext() {
      this.guideStep = 2;
    },
    handleKnow: function handleKnow() {
      var hasShowReportGuideIds = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('hasShowReportGuideIds');
      if (hasShowReportGuideIds) {
        hasShowReportGuideIds = JSON.parse(hasShowReportGuideIds);
      } else {
        hasShowReportGuideIds = [];
      }
      hasShowReportGuideIds.push(this.userInfo.userId);
      __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set('hasShowReportGuideIds', hasShowReportGuideIds, { expires: 3650 });
      location.href = '/report-web';
    }
  }
});

/***/ }),

/***/ 358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_getUnreadMessageInfo__ = __webpack_require__(188);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      visible: false,
      message: {},
      id: null,
      isRead: false,
      pushType: 0,
      loading: true
    };
  },

  methods: {
    init: function init() {
      var _this = this,
          data = {
        id: _this.id,
        platform: 'HQ',
        isRead: _this.isRead
      };
      _this.loading = true;
      _this.$axios.post('/irs-api/ces-web/user/api/v3/message/detail', _this.$qs.stringify(data)).then(function (res) {
        _this.loading = false;
        _this.message = res.data;
        if (_this.message.is_read === 0) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_getUnreadMessageInfo__["a" /* default */])(true);
        }
      });
    },
    updateId: function updateId(newId) {
      this.id = newId;
      this.init();
    },
    show: function show(id, isRead, pushType) {
      this.id = id;
      this.isRead = isRead;
      this.pushType = +pushType;
      this.init();
      this.visible = true;
      this.message = {};
    },
    close: function close() {
      this.$emit('close');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_getUnreadMessageInfo__["a" /* default */])(true);
    }
  }
});

/***/ }),

/***/ 359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_icon_notice_png__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_icon_notice_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_icon_notice_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MessageDialog_vue__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MessageDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MessageDialog_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      icon_notice: __WEBPACK_IMPORTED_MODULE_0__assets_images_icon_notice_png___default.a,
      isShowTopMessage: false,
      message: {},
      messageVisible: false
    };
  },

  components: {
    messageDialog: __WEBPACK_IMPORTED_MODULE_1__MessageDialog_vue___default.a
  },
  created: function created() {
    var _this = this;

    var postData = {
      platform: 'HQ',
      pushType: 1
    };
    this.$axios.post('/irs-api/ces-web/user/api/v3/message/notifyMessage', this.$qs.stringify(postData)).then(function (res) {
      var response = res.data;
      if (response) {
        if (+localStorage.getItem('localReadId') !== response.id) {
          _this.message = response;
          _this.isShowTopMessage = true;
        }
      }
    });
  },

  methods: {
    handleShow: function handleShow() {
      this.$refs.m_dialog.show(this.message.id, 1, true);
    },
    handleClose: function handleClose() {
      this.isShowTopMessage = false;
    },
    handleCloseDialog: function handleCloseDialog() {
      this.isShowTopMessage = false;
      localStorage.setItem('localReadId', this.message.id);
    }
  }
});

/***/ }),

/***/ 360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_logo_png__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_icon_new_png__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_icon_new_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_icon_new_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_MessageNav_MessageDialog_vue__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_MessageNav_MessageDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_MessageNav_MessageDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_getUnreadMessageInfo__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_guide_pwd_01_png__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_guide_pwd_01_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_guide_pwd_01_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_guide_pwd_02_png__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_guide_pwd_02_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_guide_pwd_02_png__);











/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this2 = this;

    var checkPassword = function checkPassword(rule, value, callback) {
      if (!value.trim()) {
        return callback(new Error('请输入密码'));
      } else if (value.length < 6 || value.length > 16) {
        callback(new Error('密码长度6-16位！'));
      } else if (!/(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*.?\s]+)$)^[\w~!@#$%^&*.?\s]{6,16}$/.test(value)) {
        return callback(new Error('6-16位，由字母、数字、符号至少两种组成，区分大小写'));
      } else if (_this2.userInfo.userName && (value.indexOf(_this2.userInfo.userName) === 0 || value.indexOf(_this2.userInfo.userName) === value.length - _this2.userInfo.userName.length && value.indexOf(_this2.userInfo.userName) > 0)) {
        return callback(new Error('密码头部或尾部不能包含用户名'));
      } else {
        callback();
      }
    };
    var checkConfirmPassword = function checkConfirmPassword(rule, value, callback) {
      if (!value) {
        return callback(new Error('请再次输入密码'));
      } else if (value !== _this2.passwordForm.newPwd) {
        return callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    };
    return {
      logoUrl: __WEBPACK_IMPORTED_MODULE_1__assets_images_logo_png___default.a,
      icon_new: __WEBPACK_IMPORTED_MODULE_2__assets_images_icon_new_png___default.a,
      guide_pwd_01: __WEBPACK_IMPORTED_MODULE_6__assets_images_guide_pwd_01_png___default.a,
      guide_pwd_02: __WEBPACK_IMPORTED_MODULE_7__assets_images_guide_pwd_02_png___default.a,
      visible: false,
      passwordForm: {
        password: '',
        newPwd: '',
        confirmPwd: ''
      },
      rule: {
        password: [{ required: true, message: '请输入登录密码', trigger: 'blur' }],
        newPwd: [{ required: true, validator: checkPassword, trigger: 'blur' }],
        confirmPwd: [{ required: true, validator: checkConfirmPassword, trigger: 'blur' }]
      },
      messageVisible: false,
      unreadMessageInfo: {
        totalCount: 0,
        data: []
      },
      urgentTimer: null
    };
  },
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_getUnreadMessageInfo__["a" /* default */])(true);
    this.getUserAndHotelInfo();
    if (this.userInfo.weekPassword && !localStorage.getItem('weakPwd')) {
      this.visible = true;
      localStorage.setItem('weakPwd', 'true');
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      global.vm.$on('refresh_message', function (res) {
        console.log(res);

        _this3.unreadMessageInfo = {
          totalCount: res.total,
          data: res.list
        };
      });
    });

    clearInterval(this.urgentTimer);
    this.urgentTimer = setInterval(this.getUrgentMessage(), 10 * 60 * 1000);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapState"])(['userInfo'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])(['getUserAndHotelInfo']), {
    handleShowMoreMessages: function handleShowMoreMessages() {
      this.messageVisible = false;
      var path = '/MessageCenter';
      if (this.$route.path === path) {
        this.$router.replace({
          path: '/Midware',
          query: {
            targetUrl: path
          }
        });
      } else {
        this.$router.push({
          path: path
        });
      }
    },
    handleGoMsgCenter: function handleGoMsgCenter() {
      if (this.unreadMessageInfo.totalCount === 0) {
        this.handleShowMoreMessages();
      }
    },
    getUrgentMessage: function getUrgentMessage() {
      var _this = this;

      if (+new Date() - window.previousAjaxTimeStamp > 9 * 60 * 1000) {
        return;
      }
      _this.$axios.post('/irs-api/ces-web/user/api/v3/message/notifyMessage', this.$qs.stringify({ platform: 'HQ', pushType: 2 })).then(function (res) {
        var response = res.data;
        if (response && response.is_read === 0) {
          _this.$refs.m_dialog.show(response.id, 0, 2);
        }
      });
      return _this.getUrgentMessage;
    },
    handleShowDetail: function handleShowDetail(message) {
      this.$refs.m_dialog.show(message.id, 0, false);
    },
    handleChgPwd: function handleChgPwd() {
      var _this4 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this4.$axios.post('/hq-web/profile', _this4.$qs.stringify(_this4.passwordForm)).then(function (res) {
            if (res.success) {
              _this4.getUserAndHotelInfo();
              if (top.vm) {
                var guidePwd = top.vm.$el.parentElement.querySelectorAll('.guide-pwd');
                if (guidePwd && guidePwd.length >= 2) {
                  guidePwd[0].style.display = 'none';
                  guidePwd[1].style.display = 'none';
                }
              } else {
                if (top.$('.guide-pwd') && top.$('.guide-pwd').length > 0) {
                  top.$('.guide-pwd').css({ display: 'none' });
                }
              }
              localStorage.removeItem('weakPwd');
              _this4.$message.success('密码修改成功');
              _this4.visible = false;
            } else {
              _this4.$message.error(res.errorInfo);
            }
          });
        }
      });
    },
    handleCommand: function handleCommand(command) {
      var _this5 = this;

      if (command === 'changePwd') {
        this.visible = true;
        this.passwordForm = {
          password: '',
          newPwd: '',
          confirmPwd: ''
        };
        this.$nextTick(function () {
          _this5.$refs.form.resetFields();
        });
      } else {
        localStorage.removeItem('menu');
        localStorage.removeItem('menuList');
        window.location.href = "/hq-web/logout";
      }
    },

    handleCloseDialog: function handleCloseDialog() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_getUnreadMessageInfo__["a" /* default */])(true);
    }
  }),
  components: {
    'message-dialog': __WEBPACK_IMPORTED_MODULE_3__ui_MessageNav_MessageDialog_vue___default.a
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),

/***/ 361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var selectIntervals = {
  0: ['00:00-00:30', '00:30-01:00', '01:00-01:30', '01:30-02:00', '02:00-02:30', '02:30-03:00', '03:00-03:30', '03:30-04:00', '04:00-04:30', '04:30-05:00', '05:00-05:30', '05:30-06:00', '06:00-06:30', '06:30-07:00', '07:00-07:30', '07:30-08:00', '08:00-08:30', '08:30-09:00', '09:00-09:30', '09:30-10:00', '10:00-10:30', '10:30-11:00', '11:00-11:30', '11:30-12:00', '12:00-12:30', '12:30-13:00', '13:00-13:30', '13:30-14:00', '14:00-14:30', '14:30-15:00', '15:00-15:30', '15:30-16:00', '16:00-16:30', '16:30-17:00', '17:00-17:30', '17:30-18:00', '18:00-18:30', '18:30-19:00', '19:00-19:30', '19:30-20:00', '20:00-20:30', '20:30-21:00', '21:00-21:30', '21:30-22:00', '22:00-22:30', '22:30-23:00', '23:00-23:30', '23:30-24:00'],
  1: ['00:00-01:00', '01:00-02:00', '02:00-03:00', '03:00-04:00', '04:00-05:00', '05:00-06:00', '06:00-07:00', '07:00-08:00', '08:00-09:00', '09:00-10:00', '10:00-11:00', '11:00-12:00', '12:00-13:00', '13:00-14:00', '14:00-15:00', '15:00-16:00', '16:00-17:00', '17:00-18:00', '18:00-19:00', '19:00-20:00', '20:00-21:00', '21:00-22:00', '22:00-23:00', '23:00-00:00'],
  2: ['00:00-02:00', '02:00-04:00', '04:00-06:00', '06:00-08:00', '08:00-10:00', '10:00-12:00', '12:00-14:00', '14:00-16:00', '16:00-18:00', '18:00-20:00', '20:00-22:00', '22:00-24:00'],
  3: ['00:00-04:00', '04:00-08:00', '08:00-12:00', '12:00-16:00', '16:00-20:00', '20:00-24:00']
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['defaultValue'],
  inheritAttrs: false,
  data: function data() {
    return {
      popoverVisible: false,
      inputValue: '\u5DF2\u9009\u62E9 ' + selectIntervals[this.defaultValue].length + ' \u4E2A\u65F6\u6BB5',
      data: [],
      defaultCheckedKeys: []
    };
  },
  created: function created() {
    var defaultCheckedKeys = [];
    this.data = [{
      id: 'all',
      label: '全部',
      children: selectIntervals[this.defaultValue].map(function (item, index) {
        defaultCheckedKeys.push(index);
        return {
          id: index,
          label: item
        };
      })
    }];
    this.defaultCheckedKeys = defaultCheckedKeys;
  },

  watch: {
    defaultValue: function defaultValue(val) {
      var defaultCheckedKeys = [];
      this.data = [{
        id: 'all',
        label: '全部',
        children: selectIntervals[val].map(function (item, index) {
          defaultCheckedKeys.push(index);
          return {
            id: index,
            label: item
          };
        })
      }];
      this.defaultCheckedKeys = defaultCheckedKeys;
      this.inputValue = '\u5DF2\u9009\u62E9 ' + selectIntervals[val].length + ' \u4E2A\u65F6\u6BB5';
    }
  },
  methods: {
    getInstance: function getInstance() {
      return this.$refs.tree;
    },
    handleCheckedChange: function handleCheckedChange() {
      var checkedNodes = this.$refs.tree.getCheckedNodes(true);
      switch (checkedNodes) {
        case 0:
          this.inputValue = '';
          break;
        case 1:
          this.inputValue = checkedNodes[0].label;
          break;
        default:
          this.inputValue = '\u5DF2\u9009\u62E9 ' + checkedNodes.length + ' \u4E2A\u65F6\u6BB5';
      }
    }
  }
});

/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_menu__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_getMenuPath__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_getRouterConf__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_ignoreMenu__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_isCRMUser__ = __webpack_require__(31);











/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      menus: __WEBPACK_IMPORTED_MODULE_3__constants_menu__["a" /* default */],
      ctx: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_isCRMUser__["a" /* default */])() ? '/hq-web/indexnew#' : '/hq-web/index#',
      active: null,
      opened: [],
      permissionList: [],
      bodyWidth: document.body.clientWidth
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapState"])(['crmUpdateClose'])),
  created: function created() {
    var _this2 = this;

    var permissionList = localStorage.getItem('menuList');
    if (permissionList === null) {
      this.$axios.get('/hq-web/reportCenter/perm').then(function (res) {
        var menus = res.data;
        localStorage.setItem('menu', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(menus));
        permissionList = menus.map(function (item) {
          return item.id;
        });
        localStorage.setItem('menuList', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(permissionList));
        _this2.permissionList = permissionList;
      });
    } else {
      this.permissionList = JSON.parse(localStorage.getItem('menuList'));
    }
    this.checkBodyWidth();
    this.handleRouteChange();
  },

  watch: {
    '$route': function $route() {
      this.handleRouteChange();
    }
  },
  methods: {
    getMenuPath: __WEBPACK_IMPORTED_MODULE_4__util_getMenuPath__["a" /* default */],
    handleRouteChange: function handleRouteChange() {
      var _this3 = this;

      if (this.$route.path !== '/Midware') {
        var checkPermission = true;
        __WEBPACK_IMPORTED_MODULE_6__constants_ignoreMenu__["a" /* default */].forEach(function (ignoreMenu) {
          if (_this3.$route.path === ignoreMenu) {
            checkPermission = false;
          }
        });
        if (checkPermission) {
          var config = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_getRouterConf__["a" /* default */])(this.$route.path);
          this.active = config[1].id.toString();
          this.opened = this.bodyWidth <= 1280 ? [] : [config[0].id.toString()];
        }
      }
    },
    checkMenuAuthority: function checkMenuAuthority(item) {
      var _this4 = this;

      if (item.id === '1' || item.id === '14010') {
        return true;
      }
      var flag = false;
      flag = ('' + (item.sign || [item.id])).split('_').some(function (i) {
        return _this4.permissionList.indexOf(window.parseInt(i)) >= 0;
      });
      return flag;
    },
    checkBodyWidth: function checkBodyWidth() {
      var _this = this;
      window.onresize = function () {
        _this.bodyWidth = document.body.clientWidth;
        _this.opened = _this.bodyWidth < 1280 ? [] : _this.opened;
      };
    },
    jump: function jump(child, menu) {
      var path = child.path;
      if (this.$route.path === path || this.$route.path === path + '/') {
        this.$router.replace({
          path: '/Midware',
          query: {
            targetUrl: path
          }
        });
      } else {
        this.navigateTo({
          path: path
        });
        _hmt.push(['_trackEvent', 'click_subMenu', child.name, menu.name]);
      }
    }
  }
});

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_getMenuPath__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_getRouterConf__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_ignoreMenu__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_isCRMUser__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_checkAgencyType__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_cookie__ = __webpack_require__(25);












/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['menus'],
  data: function data() {
    return {
      ctx: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_isCRMUser__["a" /* default */])() ? '/hq-web/indexnew#' : '/hq-web/index#',
      active: null,
      opened: [],
      permissionList: [],
      bodyWidth: document.body.clientWidth
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapState"])(['crmUpdateClose'])),
  created: function created() {
    var _this2 = this;

    var permissionList = localStorage.getItem('menuList');
    if (permissionList === null) {
      this.$axios.get('/hq-agency/user/menu').then(function (res) {
        var menus = res.data;
        localStorage.setItem('menu', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(menus));
        var menuList = {};
        for (var i = 0; i < menus.length; i++) {
          var sysCode = menus[i].systemCode;
          var menu = menus[i].menu;
          var idList = [];
          for (var _i = 0; _i < menu.length; _i++) {
            idList.push(menu[_i].id);
          }
          menuList[sysCode] = idList;
        }
        localStorage.setItem('menuList', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(menuList));
        _this2.permissionList = menuList.chain || [];
      });
    } else {
      this.permissionList = JSON.parse(localStorage.getItem('menuList')).chain || [];
    }
    this.checkBodyWidth();
    this.handleRouteChange();
  },

  watch: {
    '$route': function $route() {
      this.handleRouteChange();
    }
  },
  methods: {
    getMenuPath: __WEBPACK_IMPORTED_MODULE_3__util_getMenuPath__["a" /* default */],
    handleRouteChange: function handleRouteChange() {
      var _this3 = this;

      if (this.$route.path !== '/Midware') {
        var checkPermission = true;
        __WEBPACK_IMPORTED_MODULE_5__constants_ignoreMenu__["a" /* default */].forEach(function (ignoreMenu) {
          if (_this3.$route.path === ignoreMenu) {
            checkPermission = false;
          }
        });
        if (checkPermission) {
          var config = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_getRouterConf__["a" /* default */])(this.$route.path);
          if (config[1] && config[1].id) {
            this.active = config[1].id.toString();
            this.opened = this.bodyWidth < 1280 ? [] : [config[0].id.toString()];
          }
        }
      }
    },
    checkSCM: function checkSCM(item) {
      if (item.id === '190' && this.permissionList.indexOf(window.parseInt(item.id)) === -1) {
        return true;
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_checkAgencyType__["a" /* hasType */])('SCM') && (item.id === '70' || item.id === '80' || item.id === '190' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_cookie__["a" /* getCookie */])('pingxin_fe_show_history_menu'))) {
        return true;
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_checkAgencyType__["a" /* hasType */])('NEW_CRM') && (item.id === '2000000050' || item.id === '2000000120')) {
        return true;
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_checkAgencyType__["a" /* hasType */])('SCM_DC') && (item.id === '70' || item.id === '80' || item.id === '190' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_cookie__["a" /* getCookie */])('pingxin_fe_show_history_menu'))) {
        return true;
      } else if (item.id === '9600' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_cookie__["a" /* getCookie */])('pingxin_fe_service_center')) {
        return true;
      } else {
        return false;
      }
    },
    checkMenuAuthority: function checkMenuAuthority(item) {
      var _this4 = this;

      if (item.id === '1' || item.id === '14010') {
        return true;
      }
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_cookie__["a" /* getCookie */])('pingxin_fe_service_center') && item.id.indexOf('960') >= 0) {
        return true;
      }

      var flag = false;
      flag = ('' + (item.sign || [item.id])).split('_').some(function (i) {
        return _this4.permissionList.indexOf(window.parseInt(i)) >= 0;
      });
      return flag;
    },
    checkBodyWidth: function checkBodyWidth() {
      var _this = this;
      window.onresize = function () {
        _this.bodyWidth = document.body.clientWidth;
        _this.opened = _this.bodyWidth < 1280 ? [] : _this.opened;
      };
    },
    jump: function jump(child, menu) {
      var LXAnalytics = window.LXAnalytics || function () {};
      if (child.id === '9601') {
        LXAnalytics('moduleClick', 'b_eco_pbtt2gna_mc', {}, { cid: 'c_eco_m81yc73q' });
        window.open(child.path);
        window.location.reload();
        return;
      } else if (child.id === '9602') {
        var curSsid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_cookie__["a" /* getCookie */])('SSID');
        LXAnalytics('moduleClick', 'b_eco_m9vg606j_mc', {}, { cid: 'c_eco_m81yc73q' });
        window.open(child.path + '?ssid=' + curSsid);
        window.location.reload();
      } else if (child.id === '9603') {
        LXAnalytics('moduleClick', 'b_eco_fd8xztbp_mc', {}, { cid: 'c_eco_m81yc73q' });
      }
      var path = child.path;
      if (this.$route.path === path || this.$route.path === path + '/') {
        this.$router.replace({
          path: '/Midware',
          query: {
            targetUrl: path
          }
        });
      } else {
        this.navigateTo({
          path: path
        });
        _hmt.push(['_trackEvent', 'click_subMenu', child.name, menu.name]);
      }
    }
  }
});

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_trim__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_lxTracker__ = __webpack_require__(102);




var repeatUserName = [];



/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapState"])(['userInfo'])),
  data: function data() {
    var _this = this;

    var checkPassword = function checkPassword(rule, value, callback) {
      value = value.trim();
      if (!/^[a-zA-Z0-9\w~!@#$%^&*.?\s]*$/.test(value)) {
        return callback(new Error('密码错误'));
      } else {
        return callback();
      }
    };
    var checkUserName = function checkUserName(rule, value, callback) {
      value = value.trim();

      if (/^\d{11}$/.test(value)) {
        return callback(new Error('用户名不能是11位数字'));
      } else if (!/^[a-zA-Z0-9]*$/.test(value)) {
        return callback(new Error('用户名必须由数字和/或英文字母组成'));
      } else {
        if (repeatUserName.indexOf(value) !== -1) {
          return callback(new Error('用户名已存在，请尝试其他用户名'));
        }
        _this.$axios.get('/metis-user-web/check/register/name/1/' + value.toLowerCase()).then(function (res) {
          if (res.code === 200) {
            if (res.data === 1) {
              repeatUserName.push(value);
              return callback(new Error('用户名已存在，请尝试其他用户名'));
            } else if (res.data === 0) {
              callback();
            }
          }
        });
      }
    };
    var checkConfirmName = function checkConfirmName(rule, value, callback) {
      if (value !== _this.form.newUserName) {
        return callback(new Error('两次输入的新用户名不一致'));
      } else {
        callback();
      }
    };
    var checkCaptcha = function checkCaptcha(rule, value, callback) {
      if (!/^[a-zA-Z0-9]*$/.test(value)) {
        return callback('验证码错误');
      } else {
        callback();
      }
    };

    return {
      visible: false,
      updating: true,
      disabled: false,
      reLoginDisabled: true,
      reloginBtn: '重新登录',
      form: {
        password: '',
        newUserName: '',
        confirmUserName: '',
        captcha: '',
        captchaKey: ''
      },
      rule: {
        password: [{ required: true, message: '请输入登录密码', trigger: 'blur' }, { validator: checkPassword, trigger: 'blur' }],
        newUserName: [{ required: true, message: '请输入新的总部管理员用户名', trigger: 'blur' }, { min: 4, max: 32, message: '长度在 4 到 32 个字符', trigger: 'blur' }, { validator: checkUserName, trigger: 'blur' }],
        confirmUserName: [{ required: true, message: '请再次输入新的总部管理员用户名', trigger: 'blur' }, { validator: checkConfirmName, trigger: 'blur' }],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }, { validator: checkCaptcha, trigger: 'blur' }]
      }
    };
  },

  methods: {
    show: function show() {
      this.visible = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_lxTracker__["a" /* lxCidTracker */])({ meta: { cid: 'c_eco_k6x4z1eh' } });
      this.refresh();
    },
    refresh: function refresh() {
      this.form.captchaKey = String(Date.now()).substr(-5) + Math.random().toString(36).substr(2);
    },
    handleSave: function handleSave() {
      var _this2 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          var params = {
            userName: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_trim___default()(_this2.userInfo.username),
            password: _this2.form.password,
            newUserName: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_trim___default()(_this2.form.newUserName),
            validateCode: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_trim___default()(_this2.form.captcha),
            captchaKey: _this2.form.captchaKey
          };
          _this2.disabled = true;
          _this2.$axios.post('/metis-user-web/user/modifyUserName', _this2.$qs.stringify(params)).then(function (res) {

            _this2.disabled = false;
            if (res.code === 200) {
              _this2.updating = false;
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_lxTracker__["a" /* lxCidTracker */])({ meta: { cid: 'c_eco_780z2s20' } });
              var time = 10;
              var intervalId = null;
              _this2.reloginBtn = time + 's';
              intervalId = setInterval(function () {
                time--;
                _this2.reloginBtn = time + 's';
                if (time === 0) {
                  clearInterval(intervalId);
                  _this2.reloginBtn = '重新登录';
                  _this2.reLoginDisabled = false;
                }
              }, 1000);
            } else if (res.code === 514) {
              _this2.$message({
                message: '验证码错误',
                type: 'error'
              });
              _this2.refresh();
              _this2.form.captcha = '';
            } else if (res.code === 2003) {
              _this2.$message({
                message: '密码错误',
                type: 'error'
              });
              _this2.refresh();
              _this2.form.captcha = '';
            } else {
              _this2.$message({
                message: res.message,
                type: 'error'
              });
            }
          }).catch(function (res) {
            console.log("catch", res);
            _this2.$message.error('系统繁忙，请稍后重试');
          });
        }
      });
    },
    relogin: function relogin() {
      localStorage.removeItem('agency_tree');
      localStorage.removeItem('showMTRights');
      localStorage.removeItem('storeRightsMenu');
      localStorage.removeItem('storeRightsDialog');
      localStorage.removeItem('weakPwd');
      localStorage.removeItem('menu');
      localStorage.removeItem('menuList');
      window.location.href = '/account-web/#/' + this.userInfo.belongId + '/' + this.form.newUserName;
    }
  }
});

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(12))(138);

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_cookie__ = __webpack_require__(25);







var CODE_MAPPING = {
  query_limit: 429429 };

__WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.request.use(function (config) {
  window.previousAjaxTimeStamp = +new Date();
  return config;
});

__WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.response.use(function (response) {
  var resUrl = response.request.responseURL;
  if (resUrl && resUrl.indexOf('zeus-hq-web') !== -1 && response.data.code && response.data.code === CODE_MAPPING.query_limit) {
    global.vm.$message.error('您的操作过于频繁，请稍后再试');
  }
  if (response.data.indexOf && response.data.indexOf('用户登录') !== -1) {
    window.location.href = '/hq-web/login';
  }
  return response.data;
}, function (error) {
  var checkWhiteList = function checkWhiteList(url) {
    var whiteList = ['aliyuncs.com'];
    url = url || '';
    return whiteList.some(function (item) {
      return url.includes(item);
    });
  };
  if (error && error.response && error.response.request && checkWhiteList(error.response.request.url)) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  }
  if (!error.response || error.response.status === 401) {
    window.location.href = '/hq-web/login';
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$axios = __WEBPACK_IMPORTED_MODULE_2_axios___default.a;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$qs = __WEBPACK_IMPORTED_MODULE_3_qs___default.a;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('encrypt', function (value, type) {
  if (/^\d{11}$/.test(value) && type === 'phone') {
    return (value + '').replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2');
  } else if (type === 'name') {
    return value.slice(0, 1) + '**';
  }
  return value;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('money', function (value, divide) {
  if (isNaN(value) || value === null) {
    return '--';
  }
  return (+value / (divide || 100)).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(12))(144);

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(12))(143);

/***/ }),

/***/ 698:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 699:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(12))(141);

/***/ }),

/***/ 700:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 701:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 702:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 703:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 704:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 705:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 706:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 707:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 708:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 710:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 712:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 713:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 714:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 715:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 716:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 724:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAMAAADyHTlpAAAAflBMVEUAAAD/Ri39RSz9RSz8Qyv8Qyv8Qyr8Riv7Qyr8Qyv7RCv8RCv8RCv7RSz/Ryz/SjL9RCv8Qyr7Qyr7Qyr8Qyv8Qyv7Qyv8RCv/RS3/SjP/VT38RCv8RCv7RCv9Qyv7Qyv8Ri3/Ry7/SC7/Ryv8RCv8Qyv8RCv9Qyv8RSv7QypDrsBLAAAAKXRSTlMAM3qF+vXfTtCrg3xeRSwT6eTYyb6nkFQ3Dwft6sS1i0k9JyGsm5lqWRlmQwQAAADuSURBVDjL5c/HroMwEIXhMWBMDYQO6clt5/1f8NooskREmUV2+def5tj0moiqQsqiijpaL/Fh85MVKAJMCnZLspV4Sf4tjD93L8ktbZsCJm/27s0boaJnanzN74zMjtDVA9mGH0DeZ+jFyG+alDpz+w8zXw7EyIFuR5xKLb9YMoOuZVFhaM+iSsvjprrGruueNc3dleIrUQRmEeVcmhPYjfTkbHSytKONOksFTbrX9YMmiSUaACWTAvA+m3qAZNIKODNpH8c9k5qYNPX9lEn3gM+neyZVh4N6w7casVFjKS+SXCkp5NKQslCybobZP3AeYniKclkLAAAAAElFTkSuQmCC"

/***/ }),

/***/ 725:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAMAAADyHTlpAAAAe1BMVEUAAAD9RSz8Qyv8Qyr8Qyv9Qyv8RCv8RCv/Uz38Qyr7Qyr8RSv////8RCr7RSz/Riz/Ryz/SjL7Qyr7Qyv9RCv7Qyv9RCv8RCv8RCv/Riz8RCv8Qyv7RSv8Ri3/Ry7/SSz/gID8Qyv8Qyv7RCr9Qyr9RSv/Riz/STf7Qyqpb/uIAAAAKHRSTlMAhar79Om5tAbf1E8BvkQtKBPZybOMbV9ZNPWafUk9IwLk48h5dh0ONvuSfgAAAPBJREFUOMvl1NluwjAQheHx2KbOvpCQhL37vP8TlolaJJChR6J3/W/zaWw5iem6yRStc21hppzudRwSOZcMx9uySuWitLols7VctR7jcvhetx/35di3otno3L2dYZb/rDHvZhWRjdcnHOhc2Ii4OkJ7lZvLAyrfY/JDl18GAnrToRUhLXWjkGx0aAbRSeknRLOT9L+hfLc1xnRKzZ22u5yMgBnyKPUkcA9SrmvG6HMgCh6iCzpVQPRJ6eLf0wKiL/grED4c+O8/F9t1FqO2JCotRF/newGiqdIUonpRrtATSJJH/y2HSkeMUqaGHTSTmy8prbZEuFoigAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 726:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hq-guide-step-1.7105b6d.png";

/***/ }),

/***/ 727:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hq-guide-step-2.7c3e2a7.png";

/***/ }),

/***/ 728:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAaCAYAAACkVDyJAAAAAXNSR0IArs4c6QAAAk5JREFUSA3VlU1IVkEUhj/NNCsXCUWChhuxtAQh5CslQZAQMwI3roIo3YgWJKLiziSIFkGrEInIjSCKqStFSIKKKDKyRRH5g6CIrQqMFvW8da+M01y71z/whYeZc+bMnO+bOXMnFttFSuK3HoM9O/GbK0jyGmZhGNJgW7SXVTthEeohGz7BRQglbUtYZRPYDelwHt6CNA1H1QmjxDBBxFTBBHyBc+AnoxtLgF/qWDqJfdDy/dfUFt6GBbgSED2Gv9Yx1oPvDeQ6xpyuU3jHQcVR4Iz46wxKuI/huzAHq0nNMzzLQA1kQobXDtC2wTeIqhUmNHmTemmL4bt/hjcw+iEVXsJ90Fk1QpRkrcS3g87VVwudn3Ddd+TTWYYS3xGxNbf0DHNVWLesNSqwP8OfIuqi02cFRDHNhJqXB0twWoanFNqPUKYtvQa6vFulDyw0BJeNBX/Qlz/un6G550bchruqg+PW7GnsOj+h6+Ja8ZHM/USrUExpW+eU8Cvogm+lKlnsmbWg/vFjJeyAuDW4GVNnp8p/ZCxymH4OvJDvCMxAMyRDVJlVqnurHbtgLXITW8lW3079wyl4D6OgV+EShNlqM2E1c4rBVBbGIugBWCNdSl3QOrgHKmNVWyGsJzOhHaen7BU8tAdc9gGc+mIsQakrwPMFJSxi/B0MQqoXG6ppIEpJTwREuxLqrJ7AHQhzLP8srS1+DrpLtlwJFeOKjSXZswNsPVGToDM+BKrmB7Ce9DnblPKZnQnloC//CFyFeZBvW6W72wlPQYUV+v7+BrgQY1zuRBYYAAAAAElFTkSuQmCC"

/***/ }),

/***/ 729:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAkUlEQVRYR+1UsQ2AMAxzLgA+ZGlnuATmZuFEekFQUakKYisSi7O6clwnseDnkp/7gwLoQHHAOTcCWPJSzqq61Qt64SLStyyume0ACn8R4L1PQJfI0yNVHepGNd4i4Mn/KgBADCHcfvqlgJr/NgIRWbPC6W0EGT9daqhoZoWfV0AHmAPMAV4BHWAOMAd4BXSADhw9XashLirzcwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 730:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARYAAABACAYAAADf7VgRAAAAAXNSR0IArs4c6QAAHHlJREFUeAHtnQm4FEWSxwdFOVS8QECQQxBB8VxdFMYDFG/9RNFVd7x1vVbHGXX5vFdXdEYFxAsdYdBdxZGdcURFYGHAg/VAQQVUBOUQkEMFQZRDkf39m64mO19mdnW/ev2anYrv+1OVEZGRUZGZkZnV3Y86v0iYNmzYsAsmzwS9wI/gsjp16szjGiTqbY/CrqBl9roj123Az+AHsAwsAgvAQmx+xzWlNAJpBP4/R4DEUBdcBeYCk853PTcK9UBXcBsYA+aBNaAQSWcOGAn6gIPB1q42Ul4agTQCm3EEmNgdwGhg02swmpmPRrk5uBF8CH4G1aWfMDAF3AR2N9tK79MIpBHYTCPAZO4FvgQ2PQujUfRY3GtHczWYD2qKlmP4cbBf1G56TSOQRmAziwAT+N/Aj8CmgTDqRo/DfQvwsq1Ug+XvsT0ItI58SK9pBNIIVHgEmLBbgH7ARX1N91HoCD5yKZaBp53UxaY/6X0agTQCFRgBJqqSyiOepHC36TI6rcAMj2452UNpLHcsM31M79MIpBGogAgwQft7MoLebdSJXOS+AZgAKoVexxF9lJ1SGoE0ApUUASam3qm4aBzM+qavlG91KdYyT59EtTP9TO/TCKQRqMUIMCFPBa4XtQvg570kpbwHWAEqkabiVLpzqcWxlDadRiATASaiEsViR5bQ91DOsMME7yGHbiWxJuKMvumbUhqBNAK1EQEm4NZARx0XDbd9QqkJcCUhV/3a5A2j8S1s/9NyGoE0AmWIAJPv157ZvxJ+R9sFeL09+pXIvtb2Py2nEUgjUP0I5L7E5jJFJmgL/1aXDN7T/BBwhkN2pINXqaw7ecbxPMfUpBzE3lbY2hvoR5SVQPoR5yKecWZ1nOG59NOMriD3yZ9hbyr2Zxnl2LfYbYByd9AQbDAqqp0vwVvYNvmGSjK3+HAklvRsrh3scvhD8UE/hI1N2OyE8qlgS6vSGsqaO4stfsFitg/ORbGepaz4jMLmFIsfu4jtJiifD/I+hMkaeB/bI2MbK6RIY38ELvoB5l6u+vBfdVWoYN4YfLM73/VoBXnY2Qv8L3C95IZda6RvIuvoV3Kyo+79Ae9HFAyORwGbxwTsLkXW2FO12mxs7wL06WWov9Yib1FsY9QZAHx0QbH2pI+xC3wG4T9dis2oDvXPDNj+GFlRc8S7Y8HQgTR6TtSwdR1HBvvY4unBle2a2/wKLx+Df8eBamVknl07lUFAK5+P1iNY7RMmwN/WY0O7gbOBdgDXe3QKsWXDR1v7BDH49uprVtH4LNo2fXEQ9e4EGo++3Y76qz0oNF5vZqwvRC9Jcu36krSftK2fijXoTSwYug74On2YpyF1lra2mxvtkYDD+pSpc8DOi8j+HejvyiQ9sDR5ZLMNGAj2BS7q5mLG5IUGl45bpVLIrp5rXQmGu1Pn+BLqmVX0t39+R1J5UEySlRKcXgvoSBglK8X8WzAEPddrAURlo8inUhsM1ZcsJK/SpjOxEMQ90dT50EXfwHzVJdjMeDozfwQmg6cT8F2DzBd87VRuY/B9mEA7IRNz6TslliEeJZ9/GXXqaiHZzlFXvH9w8COWjoBKZl9GjJhXjb+TArpqtwe2xzt01hNPvf9w0Usw2wNzxyJbJ2R5XKrQXDh/A0vAdDAB+4u5RqQ+PDyLiBdd9XeFjkA/lCQj3Uq9BnekPFtRi4czsfDk5wFfQ5OtgJuB0uryvcmIcf8VOsr2M4FWCf1lOPm1M2gLlOT0bVkN+qRoDobOAFN4luBkS6hBdUq5Bl1JRy0mhlZkvStxJRBfwonC04abt0Gxfa+XpTsBH2kHPAy4Esg6fD6L/nvDrgxP4+kym4/+YHgX2/xs+XLqjfHIfoFsPfX7I1dyselQGD3A/9iC2izjr96L9AR6RxQa5+r7K4GP2mFrAMJpPoUsX23oZfuMKokFA/pzkGcGDLzpk2FQL7oWIu/o08nyV3J9GQwHb1NPq4STsKdBraPKsUDvCVwDH3ZR1Jc2JxdVo/rK2tGUg0ptR2NBn2Y1LtFJHYGFpEmTw+fTLkU2Zu5A7KorbIajrMSjybWPJVPM9bWMsYyr0AS2qtV4sQ0tjEqgFSX4uF/NeAXdE6skFphdQXvgoyk+QZav1eIoj85a+EPBA3TApx6dPDZ6qqOt6XQ67iGu2jrfCA4CpZB2Dlpdy00/lqnBoraskU/EWZ/0nU65XcTLXjVRGoFbQcssz758B+MOoEWlmMSmlfIK0AW4SG0PAhMdwjXwxjr4IZbr4+RIPyTL6BAj/VnUP1DQOLSpJ4yDwSRbUItlLeDvgN0K+KDk3bSAjl4d6H1SIcoc912J5ZRATU3yWQG5REs98g/gX0PnvOGRF2RTdx1Kz9O5o7leD24C2tEUQxpADYupkICu4twNvz/jGXRWrxHCvl4gnxYwHpw8+KZJ4ZwY2D4A2eUe29p19vPIgmzsavA/71HSLuJ2bH/tkRfLDiXdkMxs508UNO6am0zutapfA35l8ZMshsZOFf+J21fE93AcKLST1PjsC6ocH7POK/7Hg0JzX+rqz8y7DF0zhBNaQY7cWHL+uwzuEqdkE9OVrJ5DfCUPqvrVJuwoe+rLbZoET4JC2RaVHGly/SN4N8ep+Rut4lp59ac5V3MtZlUvxrtdUN49UGF+QFZIVGXgGhWqsxvTYuEjtakJmxSFxslOcRpRkqMPn0FXC5tNpyHrjI522DVBbQJGm7hk+KL4hmKcqYbf2v35EsuX2HnPZd/Hs5OABuUePmX4SgyrAnKJ7M57At5VOFadwedsEpv6A94nIhwBWjiV3MyTYT/iFtUYV0l7/xqzXtjwbFTuKqzm1dB22UfF7hpNOyG79VEs+p0FY6ID9bR7iPySje3AKcBHD1NvAkIzgS6gfB/jTAuZSY9S6AVamUzulQQ1thJLLPh0OPYuAXr3eTTwUU90xyBcCp7R3PApevihfqiD7S2xGdox5Zmtm1faOPCjzrBEmeJKjHsTBI1rJd7TqPgX7mskqURt4M9k2j2L8kjQKOIXuB5CnZbU1cApF+mTjWeBOj7asWgQuzpLuyoh0uM2SJo4smNPQtnQgFkIXuJ5F3MtlZ6iosaLbJqkNhX7UukdKuqdhSa+7f8n8Eo5BimBXAWKobYoCzbp6POpySSOcxg/h8CzF1H5v8jUTeBeY/vcGHbUN8dk9XRfbGKJ0UR8FTlgks7RIVodEiLToIu2lMra+s/KvImogK3YYtrQn0H4DRWGxKykdxEHggUx9aurpgGnBKvEkiN8Vrya5Ribbpahu2ZTsfAdtnZAq6GluRQ7elldbcLOWxgRiiZ8O5hKei+hXVtESppfgJuwrd1FkvQ6xsaCqD3FX4lL41sxd5FeTGrMmole48OZjPFZCa+UpEe1okivEeS7+vZo4Fs81c/jgRauYaByiAHwAgjRhELeUlm/ORgC2hfSTVpOm38BcenmJNunUf25CJ2/XaTvXHSy24P3X0CfNNjQH8+6wtZ3ldHbCjwIlgHbzix4nV31ysnDh77AR3FW45LcpcEtBVXmqu38c8BH52T1tkBB9XwJKJYv1A/9VujCWEYsJWyG/irji5Z6UUVsnwF8NLUoYyjXjSpgUR1gnxkjcXS1V8SIn7uSyYdTEGqDbqFRbQe3jdF4uxg6SapkBrhlUEeUehZPxRbgHvrkr8TTuWIadXQGv9oom7dK7rKV2Jk/Mo5vOvPfDjRmtCMwaSaFu/FdnyKKvt94cf5rHyecSsUy8e9+6hyretyv4NIL6Gjlo4/Q64nwPqC+0h8x0ydSL6gC94dyuVT3Bum53wVPoGfudAyVRG/nBqxpLFUh/G4MU7tZu49MXeUBfdXAR/qj+CcgzDsSGsqyvZwY6LifoVxioaSB0mQj2/vv9jRQHwNFbdO91hIW4Ncn+Kcz8SUxTNfIgI7RrqnyJAUlBVfC1nHtRFDoeBf6eHMW9XUsqAlqg9EbPIa1LR8M5mflOmb4aGdbQB/qmKSxaO4afqb8NX2sa5Cy9Y9Cydyt7RqstFGoo9J+hp7KmcTCdSvg2mlcBF+T+iVQ0+RanKI2zVhleMRBz6z+1zWUWFS3PvCRxuJIYL/EjvRl+1va+zPXG+mj1WZi0dlNZ7kQKfupkYpMLFnHNaAvAOazZUV5Fz1HOYm4Z3793dpoVJNKneVKLFK7njqanF8Ae2Do+Y4HZwEfzUag1UZyTdYfwVw6Pri6Zv38Z3SbAZPky5+ovy7L1DV6j2Hq2eMjlFhci9lAjJ0N5HNEeoi38O1s2v8+YgaukY+RSsGEhKISoklmeSKC8aCHqZC9vxa/RuJXnDYc1WuMpWS4C2iQUAu+cSrz2pj8GiiRPW9OPlVybcth52hH7lqBJTlO5d1MwSVt/fcv4JqydDlJk+1WcJ3RqDo+5EdH5GPAWqNOdKt6qh8iHQV0Po6SkhLKOWAECNGpCJWgXaRVc6hLEOAtC8iq7FjQ7QK0iNl0Moy2QP1bVlLSIHkMotEejoaPgNcNvOGQ1RoLn+fhs/xqDswkafqkcRQag6auxtFRoI/JNO4lzywiZmLRgBFCJAfU6TpXViQRTP3RntdwrlBiqQ3/NVkKJW+XX6XUiezYOwq7HOmZV61yPmrpEwT4SiwadOYOJFJ37VhC75W0uNUWvULDn4BOlgOaN1qt37D4tV5kPkzDiWnMCY09zV/1g0h98TPyrzOlmP9g5+iA6lhkr0tuJhY1GDUqmY9OQvCwT1gh/Pdj+GFvlWNUqZaKksPN4HlgrhC7UX4A+Larw5E9Bey+ORjeTcCXdLS6vgQi0kDSseutiBG4hs7bmRUpUNclWg5TOzbXM+7EYK3HADd3ZaEdcSjpudpOjIeP+j2VdnL9HEZPRLYvOkV/guKwlSgLv1pg8B1gv+pAtEG7v/Px+/NCjaJ7FDrXevRWw9dXBzI7IzOxqOPVuYVWtMNpoBMGlLkrlebEcKyUCRLDrFdlC2Km1WGMqUEsG1G+C7gmnZLJvdSbbNbJ3o+i7hncd3bIxNIX4kZ5ZIXY2wYUlCSKJdX5DrieUTsQnc/NxLKIso+a+wRl4g+jHSV0+winZKxfOF9C3O1FoEyueZv5EskQcJtDQ0elJ/H7OPz2vrtC3hS9QcCXH/TD4tw4NVdOdbxWtEKkwXFlIaValn9F+4V2JAp2JZAGpOuIEPSNjtb2+8eAkm8ABKrkREp2PiolsWhs6TjkIrW1gyWYb5XNYilHMbN+te6ZPDqm3QuU/JaCJVno/gAQSsqIy0/ZRNeXlsd6Wv8l/Ac8Mn3Urg3IY2APj8578O82ZWZiWYlAEzIOXUBjvpUyTv2SdDSZgI4OhWgVCtqBheiLkLCCZKGkE5JV5xFC7zF8CcLbHgNbuxFNPBdpobLfs4QSS5z+d7WTGI/nUWLR+N87e43ue1DW2Ks4wmcttJeBBR7nLmFuaSfmov+AeapLAG8F0Dfs8547l1gQaPWb7alss7eF0Q9HzKOUrZNomba0Xf5voBdRpxUwro/9hBDNCgkrRKZnMI8I5XKrsach+VLKjkXmfDtEJcdmUjBoIfe+3VitJxb5yXzRzy70vRoT31KOcwyKo2OEI3ebeX+RK+XfHMe8GATGg1vyRRtL+DaHu0uAb0zpLwZcaNalfDnlPibPuv8tdqdYvLyXiJK9YysEyscguzkgT1qkVaIX2B7sE8N4aDXXoJ0Zw0Y5VJScdaxxkfz0DQINztAADclcbWV4DCTFzZdYtCqVmljmZhpw/2MnCx03fO20wMeGbjMVxV0f8CbjP8/RADQFBV9IZ3V6Bmy2QqYk0B3oxb6TSAJjENzoFG4ch4/SVmbh5tobPR2RfHNJ71X+6LKV27FkhX/jGgqIbUO/XbjQZiZdpo0bsHmlYXeWce+61fY69I5Bq6eydyWQBpl2Yy7S9lXvJ1xUD6b9lt+lVyxPsfMlFk12HZlLoVC8W1sG1Y5vh6Njk310sqrXXpGxqt8a6T1Ql4AXmjdvI58KpoOXKDt3//D1S/zXs7rncfWRFiHN3/6gn09JfJLBAC6PenTqw3+aNkdxfRJonLloBEzvTsZ+mA9Q/hTs5bLk4GmlfQwn9LcaBjvk1WZhW87fYxmabZXt4g4wfAGR7gf4q9W3nKTv1xxKg+cDM6HvTtmXBJU4hlLvC642qY/a20yjfDv1TjLKul0LBvLsn1l8s6j3KzuZDON+MXVXG+VibucGlPMSC22sx3f18f6OOjqG7wbmOWQ1xsIfjXW9aN4eKEZKvk2z0FEuuhe/FdDVR9I3j39f+xThnw4OC8gj0YvErXdUiHH9LTpKgKc4dLW4HOfgR6y3uLmI9rTwOSkvsaCoP4b9JppxE4uMalL8gXoa5Hdgo9SBJ1s5wp6Sw+/Bv+SYG2+UmQutmi3QMSevZSLz1WybV92yBp5vy/gzsu+BXo6dB+KS7B0bV9nSO5CyYJOSykCbaZQ1QTSBXORKcC49F28+TA1EVxJtTX/r43jFKaJPohvrqpjo04mJFr/GivimBPcE0LhSstcuMzS+EAdJz6b3hYvAEjCLZ/+Jq4tGwVwDPgIng3OAi75yMX082tNcvwD5i+CXPj0HX378E/WXOWQ5Vl5iyXL14qxYUmf3AYfhrP7nuFeLNWDqY0MrbV+wr8nP3qtDXX6bqh3MgnWvVVtbxqRJg801adSOJpQS4gugKVC8NgA9RxegVdhFGlCTwGqgOiLVqwc6AdnykVbBD4EGbFRXPhSakNo9+CbNZ8hKpcVU/AY0dxjYFZ5iYC4YGsA+Kmbh89kohq8dw0FWBS0UOqbq2KZYLwV6RkFlLYgHABf1Z44MdglsHnrj4Qn62Ff94kssvj5TVSdhezk2z0T4MnAtQna9WTBOp54WiSC5Jmj7YI2wsCvisTg7gutjYCJOaHIUJOpoYHUHV4DjAxW0M9BAnBrQcSWkSH0KNzOiQoJXbZGVXFykQfgTsfgrVyFD2YEynYKShIv035Tc5RJQd0/4b4AmLjm8h6h7p0cWYsuuj2b6BDH4K9DRouVKLI3hNwNmYlEfrQfqb5v2thk1XB6H/T5AyWNJ9qoVW8+0ijiv45pH9E87GL7EomRfCvkWrlJsZerg+yJ8/RWFyaBBwJDmsX4A+mlAJyfKSyw0oNVT263qkGzqXCjoo+FXub4J5JC2a3JQpEmot+GaVN1AD6AtbhzqgNJolyLtKfi+DlWV5wiOBmzSpAnjWzU0CLW62aRV0JfIox2OXSdTVgfzrJqovsQSxdlZP8D0JTkdU0pOLPirH/HNwYae2ab6MNoA0/5cyprIiqtNHbDVEJs/2IKaKNPOJ9gViqG8uWVVjHaQFrvWiifScqGkpQS/D1ACKkh16aBmaJ0GOoPeoBFIiuSIcDXQZF4FNGFEepDtQClBdg022RRpovomqyb4n6VUAxRa6RcwOKusavhwLtjK48s0+ErGTqLfXCu5qVt0XLGpxNjRNGLca3uvxFAd6p+trKOcjnQi+akdnZlU9MmFtunaerv6ugX8lnYdyhHpOcyJorbM9zeR3t/1lfgq+f0OXBcjEBqng6nTmL65v5C+DA8FxxVSTECuiaDjQhK0TcDI0cg0cF00nKBola8JCu2SqiQIOmhXnDgr4Ih2VlESDqglKtoZa7t7LH4G/xuPLBab53kbRZ3p49IHKB7uUK4PT8ehvGRk6CmxmAlbi9paQ/53f8v404cjj4Ni+kNz+L7s2O0TGp/qgKQmO6bKRs4tMA+s1U+7LxethvmIS1BdHu0qkR0csDPZIfsNvMYOvljaWQ3zyGqSvQfGlVxc9D4DKdpluOQ2rxhdu25Ufje6cVxdR6pITQumkk9Eeqeh/i96FxcZqJBrEjHVS+B2PM9IEEoqobY0dodhZ0dfXJRYBviEFczXCzQX7QfzUJcAnv6vlekeWXXZOka29xjRSjnJlNEh+1C+zORZ94PxdYHFK0fxQBrxTb43i3BA4yoJ0o7Ft2sLJRa9hNQ7vIjUBzpuJeVXZLfcV99OPLYfjL0jUR4HugYqvYLsEBA68vRGrl/Y7+myo8z+PBgNynEccvlQCs+3BdZkNc/Wke3l3NwTFWrgejo2FUsXTYWpdwUZoiO0Re8HttvIqfLvfDjRu4gqwhpm+AbbCtqdaLWtdxa+JKRJfTPP+jBXX2KwzOWKsjuPxKp6nwMl2LbApv2wvzN639gCyttmEYlWcrMK+PyN9CruyjPqyKJEuRu4POBgwaSJrUupr7Gl+PhoCIKriat2eJOooyOw6piJmmKGuvDvOHT0pyLGZHmZS10Y+pajtjbayvu2wWad2r7/Dgem2U7wDO3hnWPzs+Xf85yzPbJqsWlXCeLsgBG9K9FWPKKruekZFRzXG9D37chs9dBECclsO1H5BW406HSWFsmGkspQfPpCDIOUAOeADgbPvNUkuAgoURRD2oLfCvrR5mriO4J7LRh24l4PT+/aXIlF49h8D/eN+gBbocmnZ7VjZpdRiU2huiFZrgH83YvCKKAxJtgxgJUj7e6chB0dC7WwXutU2MhU3O8EdxCr3DGI+8epr4VRCacNsKklDP23Qfoj2g9EwoyjMGYgUHL5z0hQwdf38E2D2qabYDSymZTfAQ86+EmyvvUYmwQ/F1NirAF1ukdXW/UB9MVzHrnNVuevsZlGWfaKItoeTgWhIKG7iufRhB8EOnoquHaPHtU89o5G6QbuHwW2Lf2SeKGhZ962omAmkXlZoZngTX3d67hk767ssl0nVF4XEIZkZjWNZz1LiLSzGAo08asQfdQUpsbUEVWEmxgav9cTT6cN+PrFdA901NfHbqqWu1PiGoBOF66Xo78iL3MiuBeBOrKS6VIcH2w6iN/dKWsrpmOGSdrddEd/sslM+p72m2BzL2AOZg0e/SYpb4Kjuzv81sAm/cfbn9rMUBlbmtCdLR31qRLOa9jTEaBGCR80+OVDvWxD6gNBia9Yku+a/O/i+7JiK0f6+KRVVBMhovew9zH8XWForEQ7MsnVpo7Keq+wAzgGyH/5MY56cXePqG+irA9HwjHHRNQ3o7GrnWCQsCE/ugHtvux4ypZ2g3OwNYOrk7ChsdkTKEm6bGjnNw0bs7gGCVvaiHQFSlYuW/J3FLYUz02kBwHPgEql2Timzs8R5e2BvojnoitziulNGoE0ArUXAWZnQ1Dov1p1TeJy8C61I0OjT3gafszWTctpBNII1GIEmKjbgGc9E7a22PpoS1utHFG+xuPMy/Ab5BTTmzQCaQQqIwKaxOB+z8QtN/tzGmxtRoZyb6Cfftv0Kgzz5Z9ZLb1PI5BGoBIiwCQ9Fyy2Z28ZywtpK+/LUJT1f7h85/BhArzGlRC31Ic0AmkECkSAydoe6Cu8+s5LOWk6je1vuke5F1jpcELvhdKdihms9D6NwOYQASbuUUDvOsqRYJ6iHX2slSPKFwN9acqmgTCijztz+ulNGoE0AptRBJjERwDtYPTT9iRJCWsCOMEMB2X9eYdbgP6mh0lfU7jQ1E3v0wikEdjMI8Ckbgv+FYwGS0EptIZKU0F/0A3oiz95BO8iYNMYGPvkKaaFNAJpBCoiAlUmcaleMcmbUVcTXe9EOgF9FVm/2dBvHPQxsb6p9wP4FiwE+qbfdKAf6c3k23rerzlj+zx0ngL6luAk8BDQ31ZROaU0AmkEKiwCiSUW13OREPTVab370NealVj0d1/1m4yiCDuqfxjQ1+P1d0HShFJUBFPlNAJpBNIIpBFII7CZR+D/AFopjhvQwYQpAAAAAElFTkSuQmCC"

/***/ }),

/***/ 731:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/org-guide.61878c7.png";

/***/ }),

/***/ 732:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(698)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(746),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 733:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(710)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(758),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 734:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(708)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(756),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(703)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(751),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(701)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(749),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(705)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(753),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 738:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(699)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(747),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(706)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(754),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(707)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(755),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(713)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(761),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 742:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(704)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(752),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 743:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(715)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(763),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(700)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(748),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 745:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(714)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(762),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 746:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agency-tree"
  }, [_c('el-popover', {
    ref: "popover",
    attrs: {
      "placement": "bottom",
      "width": "300",
      "trigger": "click"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('AgencyTreeCore', _vm._g(_vm._b({
    ref: "treeCore",
    on: {
      "nodeClick": _vm.handleClickNode,
      "checkedChange": _vm.handleCheckedChange
    }
  }, 'AgencyTreeCore', _vm.$attrs, false), _vm.$listeners))], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请选择组织机构",
      "readonly": ""
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }, [_c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }],
    attrs: {
      "slot": "append",
      "icon": "el-icon-arrow-down"
    },
    slot: "append"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 747:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "font-tip"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "placement": _vm.placement
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.tips), function(item) {
    return _c('p', {
      staticClass: "tip"
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")])
  })), _vm._v(" "), _c('i', {
    class: _vm.iconClass
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 748:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "sidenav-new"
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.active,
      "unique-opened": true,
      "default-openeds": _vm.opened,
      "collapse": _vm.bodyWidth < 1280
    }
  }, _vm._l((_vm.menus), function(menu, idx) {
    return _c('div', {
      key: idx
    }, [(menu.children) ? _c('div', [(!_vm.checkSCM(menu)) ? _c('el-submenu', {
      attrs: {
        "index": ("" + (menu.id))
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: ("iconfont " + (menu.icon))
    }), _vm._v(" "), (menu.hasNewPoint === true) ? _c('el-badge', {
      staticClass: "item px-badge",
      attrs: {
        "is-dot": ""
      }
    }, [_c('span', {
      staticClass: "menu-name"
    }, [_vm._v(_vm._s(menu.name))])]) : _c('span', {
      staticClass: "menu-name"
    }, [_vm._v(_vm._s(menu.name))])], 1), _vm._v(" "), _vm._l((menu.children), function(child, idx) {
      return [((_vm.checkMenuAuthority(child))) ? _c('div', {
        key: idx,
        class: child.className ? child.className : null
      }, [((child.path && child.path !== '/Member/MemberTransfer') || (child.path === '/Member/MemberTransfer' && !_vm.crmUpdateClose)) ? _c('el-menu-item', {
        attrs: {
          "index": ("" + (child.id))
        },
        on: {
          "click": function($event) {
            _vm.jump(child, menu)
          }
        }
      }, [(child.hasNewPoint) ? _c('el-badge', {
        staticClass: "item px-badge",
        attrs: {
          "value": "NEW"
        }
      }, [_vm._v("\n                  " + _vm._s(child.name) + "\n                ")]) : _c('span', [_vm._v(_vm._s(child.name))])], 1) : (child.oldPath) ? _c('a', {
        attrs: {
          "href": _vm.ctx + _vm.getMenuPath(child.oldPath)
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": child.id
        }
      }, [_vm._v(_vm._s(child.name))])], 1) : _vm._e()], 1) : _vm._e()]
    })], 2) : _vm._e()], 1) : _c('div', [(menu.path) ? _c('router-link', {
      attrs: {
        "to": menu.path
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": ("" + (menu.id))
      }
    }, [_c('i', {
      class: ("iconfont " + (menu.icon))
    }), _vm._v(" "), _c('span', {
      staticClass: "menu-name",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(menu.name))])])], 1) : _c('a', {
      attrs: {
        "href": _vm.ctx + _vm.getMenuPath(menu.oldPath)
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": menu.id
      }
    }, [_c('i', {
      class: 'iconfont ' + menu.icon
    }), _vm._v("\n            " + _vm._s(menu.name) + "\n          ")])], 1)], 1)])
  }))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 749:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-date-shortcut"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "el-date-shortcut__item",
      on: {
        "click": function($event) {
          _vm.handleItemClick(index)
        }
      }
    }, [_c('a', {
      class: {
        'el-date-shortcut__a': true, active: index === _vm.active
      },
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item.text))])])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 750:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isReady) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.showUpdateName) ? _c('div', {
    staticClass: "update-name-wrap"
  }, [_c('div', {
    staticClass: "guide-shadow"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-content"
  }, [_c('p', [_vm._v("系统检测到账号风险")]), _vm._v(" "), _c('p', [_vm._v("为了保护您的账户安全，请在完成总部管理员用户名修改后继续使用系统")]), _vm._v(" "), _c('div', {
    staticClass: "start-modify",
    on: {
      "click": _vm.modifyName
    }
  }, [_vm._v("开始修改")])])]) : (_vm.showLoginGuide) ? _c('comp-login-guide', {
    attrs: {
      "userInfo": _vm.userInfo
    }
  }) : [(_vm.isImgShow) ? _c('img', {
    staticClass: "img-guide",
    attrs: {
      "src": _vm.OrgGuideImg
    },
    on: {
      "click": function($event) {
        _vm.hideOrgImg()
      }
    }
  }) : _c('div', [(!_vm.isCRMUser) ? _c('NavBar') : _c('navbar-e', {
    attrs: {
      "userInfo": _vm.userInfo,
      "type": "HQ",
      "activeMenu": "chain"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "body-content"
  }, [(!_vm.isCRMUser) ? _c('SideNav') : _c('SideNavCRM', {
    attrs: {
      "menus": _vm.menus
    }
  }), _vm._v(" "), _c('comp-bread-crumb', {
    attrs: {
      "items": _vm.breadCrumbs
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('MessageNav'), _vm._v(" "), _c('div', {
    staticClass: "app-content"
  }, [_c('div', {
    staticClass: "content-inner-wrapper"
  }, [_c('keep-alive', {
    attrs: {
      "include": _vm.componentName
    }
  }, [_c('router-view')], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('comp-protocol', {
    attrs: {
      "protocol": _vm.protocol
    }
  })], _vm._v(" "), _c('UpdateName', {
    ref: "updateNameDialog"
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 751:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cw-collapse"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._t("header", [_c('div', {
    staticClass: "img-list"
  }, [_c('img', {
    attrs: {
      "src": _vm.listUrl,
      "width": "100%"
    }
  })]), _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "show-more",
    on: {
      "click": _vm.handleShowMore
    }
  }, [_c('div', {
    staticClass: "arrow-text"
  }, [_c('span', {
    class: _vm.showMore ? 'arrow-up' : 'arrow-down'
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.showMore ? _vm.collapseText[1] : _vm.collapseText[0]))])])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore),
      expression: "showMore"
    }],
    staticClass: "content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 752:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-interval"
  }, [_c('el-popover', {
    ref: "popover",
    attrs: {
      "placement": "bottom",
      "width": "300",
      "trigger": "click"
    },
    model: {
      value: (_vm.popoverVisible),
      callback: function($$v) {
        _vm.popoverVisible = $$v
      },
      expression: "popoverVisible"
    }
  }, [_c('el-tree', {
    ref: "tree",
    attrs: {
      "node-key": "id",
      "data": _vm.data,
      "default-expand-all": true,
      "default-checked-keys": _vm.defaultCheckedKeys,
      "show-checkbox": ""
    },
    on: {
      "check-change": _vm.handleCheckedChange
    }
  })], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请选择时间段",
      "readonly": ""
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }, [_c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }],
    attrs: {
      "slot": "append",
      "icon": "el-icon-arrow-down"
    },
    slot: "append"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 753:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desc-container"
  }, [_c('div', {
    staticClass: "desc-inner-container"
  }, [_c('div', {
    staticClass: "text"
  }, [(_vm.descTexts) ? _c('span', _vm._l((_vm.descTexts), function(item) {
    return _c('div', [_vm._v(_vm._s(item))])
  })) : _c('span', [_vm._v("\n        " + _vm._s(_vm.descText) + "\n      ")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 754:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "guide"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.guideStep === 1),
      expression: "guideStep === 1"
    }],
    staticClass: "guide",
    attrs: {
      "src": _vm.hqGuideStep1,
      "alt": "报表中心功能说明1"
    },
    on: {
      "click": _vm.handleNext
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.guideStep === 2),
      expression: "guideStep === 2"
    }],
    staticClass: "guide",
    attrs: {
      "src": _vm.hqGuideStep2,
      "alt": "报表中心功能说明2"
    },
    on: {
      "click": _vm.handleKnow
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 755:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowTopMessage),
      expression: "isShowTopMessage"
    }],
    staticClass: "message-nav"
  }, [_c('img', {
    attrs: {
      "src": _vm.icon_notice,
      "width": "14"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "m_title"
  }, [_vm._v(_vm._s(_vm.message.title))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.handleShow
    }
  }, [_vm._v("点击查看")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": _vm.handleClose
    }
  }), _vm._v(" "), _c('messageDialog', {
    ref: "m_dialog",
    on: {
      "close": _vm.handleCloseDialog
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 756:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comp-agency-tree-detail"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("待选")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('AgencyTreeCore', {
    ref: "tree",
    attrs: {
      "content-height": 260,
      "treeData": _vm.treeData,
      "hasFilter": false,
      "filter-node-method": _vm.handleFilterNode
    }
  })], 1)]), _vm._v(" "), (_vm.checkable) ? _c('el-button', {
    staticClass: "select-btn",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleSelect
    }
  }, [_vm._v(">>")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n        已选 " + _vm._s(_vm.selectList.length) + " 家\n        "), _c('span', {
    staticClass: "clear-btn",
    on: {
      "click": _vm.handleClear
    }
  }, [_vm._v("清空")])]), _vm._v(" "), _c('div', {
    staticClass: "select-container"
  }, [_c('ul', _vm._l((_vm.selectList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('a', {
      staticClass: "del-btn",
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          _vm.handleDelSelect(index)
        }
      }
    }, [_vm._v("删除")])])
  }))])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 758:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comp-agency-tree-core"
  }, [_c('el-input', {
    staticClass: "search-input",
    attrs: {
      "clearable": true,
      "placeholder": "请输入机构名称"
    },
    on: {
      "input": _vm.handleFilter
    },
    model: {
      value: (_vm.filterText),
      callback: function($$v) {
        _vm.filterText = $$v
      },
      expression: "filterText"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  })]), _vm._v(" "), (_vm.hasFilter) ? _c('a', {
    staticClass: "more",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.handleShowMore
    }
  }, [_vm._v("更多")]) : _vm._e(), _vm._v(" "), (_vm.hasFilter) ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-tree",
    style: ({
      height: this.contentHeight + 'px'
    })
  }, [_c('div', {
    style: ({
      height: _vm.height + 'px'
    })
  }, _vm._l((_vm.visibleData), function(item, index) {
    return _c('div', {
      key: index,
      style: ({
        'padding-left': item.level * 20 + (item.children.length ? 0 : 24) + 'px',
        position: 'absolute',
        'top': item.paddingTop + 'px'
      })
    }, [_c('div', {
      staticClass: "el-tree-node__content"
    }, [(item.children.length > 0) ? _c('span', {
      staticClass: "el-tree-node__expand-icon el-icon-caret-right",
      class: {
        expanded: item.expanded
      },
      on: {
        "click": function($event) {
          _vm.handleExpand(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "el-checkbox__input",
      class: item.checkClass
    }, [_c('span', {
      staticClass: "el-checkbox__inner",
      on: {
        "click": function($event) {
          _vm.handleCheckChange(item)
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "el-tree-node__label",
      on: {
        "click": function($event) {
          _vm.handleCheckChange(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])])
  }))])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 760:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-input', {
    attrs: {
      "clearable": true,
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.filterText),
      callback: function($$v) {
        _vm.filterText = $$v
      },
      expression: "filterText"
    }
  }), _vm._v(" "), _c('el-tree', {
    ref: "tree",
    attrs: {
      "data": _vm.treeData,
      "props": _vm.defaultProps,
      "node-key": "id",
      "show-checkbox": _vm.checkable,
      "highlight-current": "",
      "filter-node-method": _vm.filterNode,
      "default-expand-all": true
    },
    on: {
      "show": _vm.clearFilter,
      "check": _vm.handleCheck,
      "node-click": _vm.handleNodeClick
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('span', {
          class: {
            'disabled-text': data.disable
          }
        }, [_vm._v("\n      " + _vm._s(data.name) + "\n    ")])
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 761:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "height40 common"
  }, [_c('el-popover', {
    ref: "messageBox",
    attrs: {
      "placement": "bottom",
      "width": "350",
      "trigger": "click",
      "disabled": !_vm.unreadMessageInfo.totalCount
    },
    model: {
      value: (_vm.messageVisible),
      callback: function($$v) {
        _vm.messageVisible = $$v
      },
      expression: "messageVisible"
    }
  }, [_c('div', {
    staticClass: "message-box"
  }, [_c('p', {
    staticClass: "mc-title"
  }, [_vm._v("消息中心")]), _vm._v(" "), _c('ul', _vm._l((_vm.unreadMessageInfo.data), function(message) {
    return _c('li', [_c('a', {
      staticClass: "message-title",
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          _vm.handleShowDetail(message)
        }
      }
    }, [_vm._v(_vm._s(message.title.length > 23 ? message.title.slice(0, 22) + '...' :
      message.title))]), _vm._v(" "), _c('img', {
      staticClass: "message-icon",
      attrs: {
        "src": _vm.icon_new,
        "alt": "mew"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "message-time"
    }, [_vm._v(_vm._s(message.publish_time))])])
  })), _vm._v(" "), _c('p', {
    staticClass: "mc-footer",
    on: {
      "click": _vm.handleShowMoreMessages
    }
  }, [_vm._v("查看更多")])])]), _vm._v(" "), _c('img', {
    staticClass: "nav-logo",
    attrs: {
      "src": _vm.logoUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "restaurant"
  }, [_vm._v("\n    " + _vm._s(_vm.userInfo.agencyName) + "\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "account-area"
  }, [_c('li', {
    directives: [{
      name: "popover",
      rawName: "v-popover:messageBox",
      arg: "messageBox"
    }],
    staticClass: "message",
    on: {
      "click": _vm.handleGoMsgCenter
    }
  }, [_vm._v("\n      消息\n      "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.unreadMessageInfo.totalCount),
      expression: "unreadMessageInfo.totalCount"
    }],
    staticClass: "message-count"
  }, [_vm._v(_vm._s(_vm.unreadMessageInfo.totalCount))])]), _vm._v(" "), _c('li', {
    staticClass: "x-line"
  }), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "username"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n            欢迎你，" + _vm._s(_vm.userInfo.realName) + "\n            "), (_vm.userInfo.weekPassword) ? _c('img', {
    staticClass: "guide-pwd",
    attrs: {
      "src": _vm.guide_pwd_02
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "changePwd"
    }
  }, [_vm._v("\n              修改密码\n              "), (_vm.userInfo.weekPassword) ? _c('img', {
    staticClass: "guide-pwd",
    staticStyle: {
      "width": "14px",
      "height": "14px"
    },
    attrs: {
      "src": _vm.guide_pwd_01
    }
  }) : _vm._e()]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("退出系统")])], 1)], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.visible
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    staticClass: "password-info-dialog",
    attrs: {
      "model": _vm.passwordForm,
      "rules": _vm.rule,
      "label-width": "100px"
    }
  }, [(_vm.userInfo.weekPassword) ? _c('div', {
    staticClass: "guide-tip"
  }, [_c('span', {
    staticClass: "weak-warn"
  }, [_vm._v("* 温馨提示：")]), _vm._v("您的密码强度较弱，存在被盗风险，建议您更改密码以保护账户安全。")]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户名："
    }
  }, [_c('span', [_vm._v(_vm._s(this.userInfo.userName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "旧密码：",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "maxlength": 16
    },
    model: {
      value: (_vm.passwordForm.password),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "password", $$v)
      },
      expression: "passwordForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码：",
      "prop": "newPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "minlength": 6,
      "maxlength": 16
    },
    model: {
      value: (_vm.passwordForm.newPwd),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "newPwd", $$v)
      },
      expression: "passwordForm.newPwd"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("6-16位，由字母、数字、符号至少两种组成，区分大小写")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码：",
      "prop": "confirmPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "maxlength": 16
    },
    model: {
      value: (_vm.passwordForm.confirmPwd),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "confirmPwd", $$v)
      },
      expression: "passwordForm.confirmPwd"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-btns"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleChgPwd
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('message-dialog', {
    ref: "m_dialog",
    on: {
      "close": _vm.handleCloseDialog
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 762:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "custom-class": "update-username-dialog",
      "visible": _vm.visible,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false,
      "title": "修改总部管理员用户名"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [(_vm.updating) ? _c('el-form', {
    ref: "form",
    staticClass: "update-name-form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rule,
      "label-width": "200px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.handleSave($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "当前总部管理员用户名"
    }
  }, [_c('span', [_vm._v(_vm._s(this.userInfo.username))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "当前登录密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "maxlength": 20
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新的总部管理员用户名",
      "prop": "newUserName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.newUserName),
      callback: function($$v) {
        _vm.$set(_vm.form, "newUserName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.newUserName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认新的总部管理员用户名",
      "prop": "confirmUserName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.confirmUserName),
      callback: function($$v) {
        _vm.$set(_vm.form, "confirmUserName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.confirmUserName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "sm-input",
    attrs: {
      "label": "验证码",
      "prop": "captcha"
    }
  }, [_c('el-input', {
    ref: "captcha",
    attrs: {
      "type": "text",
      "placeholder": "验证码",
      "prefix-icon": "iconfont icon-yanzhengma",
      "maxlength": 4
    },
    model: {
      value: (_vm.form.captcha),
      callback: function($$v) {
        _vm.$set(_vm.form, "captcha", $$v)
      },
      expression: "form.captcha"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-captcha",
    attrs: {
      "src": ("/metis-login-web/captcha?captchaKey=" + (_vm.form.captchaKey))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "refresh-btn",
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("刷新")])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-btns"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.disabled,
      "type": "primary"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("保存")])], 1)], 1) : _c('div', {
    staticClass: "update-result"
  }, [_c('p', [_vm._v("恭喜您，修改成功！")]), _vm._v(" "), _c('p', [_vm._v("您的集团号：" + _vm._s(this.userInfo.agencyId) + " ")]), _vm._v(" "), _c('p', [_vm._v("新的总部管理员用户名： "), _c('span', {
    staticClass: "new-user-name"
  }, [_vm._v(_vm._s(this.form.newUserName))])]), _vm._v(" "), _c('p', [_vm._v("请牢记以上信息")]), _vm._v(" "), _c('p', [_vm._v("已向该账号的绑定手机 " + _vm._s(_vm._f("encrypt")(_vm.userInfo.mobile, 'phone')) + " 发送备忘短信，如您的手机号已更换，可在重新登录后通过【绑定手机号】更改")]), _vm._v(" "), _c('el-button', {
    staticClass: "retry-login",
    attrs: {
      "type": "primary",
      "disabled": _vm.reLoginDisabled
    },
    on: {
      "click": _vm.relogin
    }
  }, [_vm._v(_vm._s(_vm.reloginBtn))])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 763:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "sidenav"
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.active,
      "unique-opened": true,
      "default-openeds": _vm.opened,
      "collapse": _vm.bodyWidth < 1280
    }
  }, _vm._l((_vm.menus), function(menu) {
    return _c('div', [(menu.children) ? _c('div', [_c('el-submenu', {
      attrs: {
        "index": ("" + (menu.id))
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: ("iconfont " + (menu.icon))
    }), _vm._v(" "), (menu.hasNewPoint === true) ? _c('el-badge', {
      staticClass: "item px-badge",
      attrs: {
        "is-dot": ""
      }
    }, [_c('span', {
      staticClass: "menu-name"
    }, [_vm._v(_vm._s(menu.name))])]) : _c('span', {
      staticClass: "menu-name"
    }, [_vm._v(_vm._s(menu.name))])], 1), _vm._v(" "), _vm._l((menu.children), function(child) {
      return ((_vm.checkMenuAuthority(child))) ? _c('div', {
        class: child.className ? child.className : null
      }, [((child.path && child.path !== '/Member/MemberTransfer') || (child.path === '/Member/MemberTransfer' && !_vm.crmUpdateClose)) ? _c('el-menu-item', {
        attrs: {
          "index": ("" + (child.id))
        },
        on: {
          "click": function($event) {
            _vm.jump(child, menu)
          }
        }
      }, [(child.hasNewPoint) ? _c('el-badge', {
        staticClass: "item px-badge",
        attrs: {
          "value": "NEW"
        }
      }, [_vm._v("\n                " + _vm._s(child.name) + "\n              ")]) : _c('span', [_vm._v(_vm._s(child.name))])], 1) : (child.oldPath) ? _c('a', {
        attrs: {
          "href": _vm.ctx + _vm.getMenuPath(child.oldPath)
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": child.id
        }
      }, [_vm._v(_vm._s(child.name))])], 1) : _vm._e()], 1) : _vm._e()
    })], 2)], 1) : _c('div', [(menu.path) ? _c('router-link', {
      attrs: {
        "to": menu.path
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": ("" + (menu.id))
      }
    }, [_c('i', {
      class: ("iconfont " + (menu.icon))
    }), _vm._v(" "), _c('span', {
      staticClass: "menu-name",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(menu.name))])])], 1) : _c('a', {
      attrs: {
        "href": _vm.ctx + _vm.getMenuPath(menu.oldPath)
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": menu.id
      }
    }, [_c('i', {
      class: 'iconfont ' + menu.icon
    }), _vm._v("\n            " + _vm._s(menu.name) + "\n          ")])], 1)], 1)])
  }))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 764:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "message-dialog",
    attrs: {
      "title": _vm.pushType === 2 ? '紧急通知' : '消息详情',
      "visible": _vm.visible
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      },
      "close": _vm.close
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    staticClass: "m-head"
  }, [_c('p', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.message.title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "sub-title"
  }, [_vm._v(_vm._s(_vm.message.publish_time))])]), _vm._v(" "), _c('div', {
    staticClass: "m-body",
    domProps: {
      "innerHTML": _vm._s(_vm.message.content)
    }
  }), _vm._v(" "), (!_vm.pushType) ? _c('div', {
    staticClass: "m-footer"
  }, [(_vm.message.lastId || _vm.message.nextId) ? _c('span', [_vm._v("阅读：")]) : _vm._e(), _vm._v(" "), _c('span', [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.message.lastId),
      expression: "message.lastId"
    }],
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.updateId(_vm.message.lastId)
      }
    }
  }, [_vm._v("下一篇消息")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.message.nextId && _vm.message.lastId),
      expression: "message.nextId && message.lastId"
    }],
    staticClass: "spacer"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.message.nextId),
      expression: "message.nextId"
    }],
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.updateId(_vm.message.nextId)
      }
    }
  }, [_vm._v("上一篇消息")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("知道了")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 803:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(12))(142);

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setGrayItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeGrayItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkGrayItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var setGrayItem = function setGrayItem(prop) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Y';

  var grayListString = localStorage.getItem('grayList') || "{}";
  var grayList = {};
  try {
    grayList = JSON.parse(grayListString);
  } catch (e) {
    grayList = {};
  }
  grayList[prop] = value;
  localStorage.setItem('grayList', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(grayList));
};

var removeGrayItem = function removeGrayItem(prop) {
  var grayListString = localStorage.getItem('grayList') || "{}";
  var grayList = {};
  try {
    grayList = JSON.parse(grayListString);
  } catch (e) {
    grayList = {};
  }
  delete grayList[prop];
  localStorage.setItem('grayList', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(grayList));
};

var checkGrayItem = function checkGrayItem(item) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Y';

  var grayListString = localStorage.getItem('grayList');
  if (!grayListString) {
    return false;
  }
  var grayList = {};
  try {
    grayList = JSON.parse(grayListString);
  } catch (e) {
    grayList = {};
  }
  return grayList[item] === value;
};

/***/ })

},[342]);


// WEBPACK FOOTER //
// static/js/index.f8777788553019951d79.js